import React from 'react';
import { BsyConfig, SUBFORM_MAX_LIMIT } from '../global/BsyConfig';
import RelyProcessor_3_0 from './RelyProcessor_3_0';
import { BsyUtils } from './Utils';

import _ from 'lodash';
import { BsyFormulaCalcParser } from '../global/FormulaCalcParser';
import ShowRulesProcessor from './ShowRulesProcessor';
import tipAlert from '../Login/BsyAlertTip/Staticize';
import BsySlidePane from '../components/BsySlidePane';
import BsyAlertMenu from '../components/BsyAlertMenu';
import BsyMaskLayer from '../components/BsyMaskLayer';
import BsyDashContainer from '../components/dash/BsyDashContainer';
import BsySelect from '../components/BsySelect';
import BsySLoading from '../components/BsySLoading';
import BsyFormPane from '../components/BsyFormPane';
import BsyAlert from '../components/BsyAlert';
import BsyDialog from "../components/BsyDialog";
import { BsyFormula } from '../global/Formula';
import { dayjsUtils } from './dayjsUtils';

export default class rowExecuteRely_3_0 {

  constructor(opt) {

    // console.log(BsyUtils._isSubformWidget)
    // console.log(BsyUtils.isObjectEmpty)
    _._isSubformWidget = _._isSubformWidget || BsyUtils._isSubformWidget;
    _.isObjectEmpty = _.isObjectEmpty || BsyUtils.isObjectEmpty;

    this.form = opt.form;

    this.optAuth = opt.optAuth;
    this.dataTable = opt.dataTable;
    this.ignoreAuth = opt.form.options.ignoreAuth;
    this.popupFormPath = opt.form.options.popupFormPath || [];
    this.appId = opt.appId;
    this.formId = opt.formId;
    this.entryId = opt.formId;
    this.dataId = this.form.options.dataId;
    this.rowElement = opt.rowElement;
    this.relyCache = {};
    this.fieldMap = {};

    this.delayLinkDataMap = {};
    this.labelMap = this.form.labelMap
    this.itmes = opt.items;
    this.mode = opt.mode;
    this.validators = this.form.options.validators;
    this.onWidgetError = opt.onWidgetError;
    this.fieldShowRules = this.form.options.fieldShowRules || [];
    this.subformFieldShowRules = this.form.options.subformFieldShowRules || []


    this.rely = new RelyProcessor_3_0({
      formRely: this,
      formId: this.formId,
      items: opt.items,
      formEvents: [],
    }, this.labelMap);
  }

  apL = (r, d, c) => {
    console.log('checkRelyAsyncState', r, d, c)
  }

  checkRelyAsyncState = function () {

    let that = this;
    if (this.ajaxLoading) {
      if (this.form.showMessage) {
        this.form.showMessage();
      }
      return false;
    }

    if (this.rely.checkAsyncState(true)) {
      if (this.rely.checkAsyncState(false, true)) {
        return true;
      } else {


        if (!_.isObjectEmpty(this.rely.errorMap)) {

          BsyUtils.forEach(this.rely.errorMap, (key) => {

            let name = key;
            if (_._isSubformWidget(key)) {
              let r = key.split(".");
              name = r[0];
            }

            // 弹出提示
            BsyAlert({
              title: React.language("form.submit.async2"),
              msg: React.language("form.submit.async2.desc", { "name": that.labelMap[name] }),
              type: "warning",
              text4Ok: React.language("iSee"),
              OkType: "red",
              ok: function () {

                return true;
              },
            });

            that.onWidgetError && that.onWidgetError({
              name: name,
              errMsg: '',
            })

            return false;
          })
          return false;
        }


        if (this.form.showMessage) {
          this.form.showMessage();
        }
        if (this.rely.isAsyncCalculating()) {
          this.apL('RELY_PROMPT', {
            appId: this.appId,
            entryId: this.entryId
          }, "rely_calculate");
        } else {
          this.apL('RELY_PROMPT', {
            appId: this.appId,
            entryId: this.entryId
          }, "rely_fail");
        }
        // console.log('checkRelyAsyncState ', false, this.errorField)
        return false;
      }
    } else {
      if (this.form.showMessage) {
        this.form.showMessage();
      }
      // console.log('checkRelyAsyncState ', false, this.errorField)
      return false;
    }
  }

  // checkRelyAsyncState = function (e, t) {

  //   // return this.rely.checkAsyncState(!0) ? !!this.rely.checkAsyncState(!1, !0) || (this.setMessage && this.setMessage({
  //   //   message: "field",
  //   //   type: "progress",
  //   //   callback: {
  //   //     successFn: e,
  //   //     failFn: t
  //   //   }
  //   // }),
  //   //   this.rely.isAsyncCalculating() ? that.apL('RELY_PROMPT', {
  //   //     appId: this.appId, entryId: this.entryId
  //   //   }, "rely_calculate") : that.apL('RELY_PROMPT', {
  //   //     appId: this.appId,
  //   //     entryId: this.entryId
  //   //   }, "rely_fail"),
  //   //   !1) : (this.setMessage && this.setMessage({
  //   //     message: "event",
  //   //     type: "progress",
  //   //     callback: {
  //   //       successFn: e,
  //   //       failFn: t
  //   //     }
  //   //   }),
  //   //     !1)

  // }



  getFieldPath = function (e) {
    var t = e.path;
    if (e.isSubformWidget()) {
      var n = t.split(".")
        , r = n
        , i = r[0]
        , o = r[1];
      t = [i, e.rowId, o].join(".")
    }
    return t
  }
  getField = function (e, t) {
    if (_._isSubformWidget(e) && !_.isNil(t)) {
      var n = e.split(".")
        , r = n
        , i = r[0]
        , o = r[1];
      return this.fieldMap[[i, t, o].join(".")]
    }
    return this.fieldMap[e]
  }
  getFieldIndex = function (e, t) {
    if (_._isSubformWidget(e) && !_.isNil(t)) {
      var n = e.split(".")
        , r = n
        , i = r[0]
        , o = r[1];

      let id = this.fieldMap[i].value[t].id;
      return this.fieldMap[[i, id, o].join(".")]
    }
    return this.fieldMap[e]
  }
  getLinkValue = function (e) {
    var t;
    switch (e.type) {
      case "user":
      case "dept":
        if (_.isString(e.cacheValue)) {
          t = e.cacheValue
        } else {
          t = _.isNil(e.cacheValue) ? null : e.cacheValue.id || e.cacheValue._id;
        }
        break;
      case "linkdata": {
        if (e.linkValue) {
          t = e.linkValue.key
        } else {
          t = null;
        }
        break
      }
      case "usergroup":
      case "deptgroup":
        t = [];

        _.map(e.cacheValue, (function (e) {
          if (_.isString(e)) {
            t.push(e);
            return e
          } else {
            if (!_.isNil(e)) {
              t.push(e.id || e._id);
            }
            return e;
          }
        }
        ));
        break;
      case "checkboxgroup":
      case "combocheck": {
        t = e.linkValue || [];
        break
      }
      default:
        t = e.linkValue
    }
    return t
  }
  getFields = function (e) {
    var t = this;
    if (_._isSubformWidget(e)) {
      var n = e.split(".")
        , r = n//(0, a.Z)(n, 2)
        , i = r[0]
        , o = r[1]
        , l = this.fieldMap[i]
        , u = [];
      return _.forEach(_.get(l, "value"), (function (e) {
        var n = _.get(t.fieldMap, [i, e.rowId, o].join("."));
        n && u.push(n)
      }
      )),
        u
    }
    return [this.fieldMap[e]]
  }
  removeField = function (e) {
    var t = this.getFieldPath(e);
    _._isSubformWidget(e.path) && e.rowId && this.rely.clearSubformRow(e.path, e.rowId);
    delete this.fieldMap[t]
  }
  removeSubformAllField = function (e) {
    let fields = [];
    _.forEach(this.fieldMap, (val, key) => {
      if (key.indexOf(e + ".") > -1) {
        fields.push(key)
      }
    })
    _.forEach(fields, (val) => {
      // this.rely.clearSubformRow([names[0], names[2]].join('.'), names[1]);
      delete this.fieldMap[val]
    })
  }
  registerField = function (e) {
    var t = this
      , n = this.getFieldPath(e);

    if (this.fieldMap.hasOwnProperty(n)) {
      var ret = this.fieldMap[n];
      // console.log(` 已存在 uuid=${ret.uuid} ${n}`)
      // console.log(` 已存在 uuid=${e.uuid} `)
      return ret;
    }

    this.fieldMap[n] = e;
    e.setForm(this.form)
    this.rely.addDefaultRely(e);

    if (e.type == 'subform') {
      if (_.isObjectEmpty(e.value)) {
        if (t.ignoreAuth || e.allowCreate) {
          e.setValue([{
            status: 'new',
            isNew: true,
            rowId: BsyUtils.Ids24(),
          }])
        }
      }
    }
    return e;
  }


  fireDefaultRely = function () {
    if (this.isEditMode || this.isDraftMode)
      this.rely.fireDefaultRely(this, []);
    else if (this.form.cacheEnable && this.form.needCache)
      this.rely.fireDefaultRely(this, []);
    else {
      var e = this.rely.getDefaultRely();
      this.rely.fireDefaultRely(this, e);
      // (0,
      //   I.xbD)(e) || (0,
      //     I.apL)(b.sRB.RELY_FORM_DEFAULT)
    }
  }


  batchRowRely = function (e) {
    let ids = [];
    _.forEach(e.getValue(), item => {
      ids.push(item.rowId)
    })
    this.clearRelyCache();
    this.rely.batchRowRely(this, e, ids)
  }

  dealRely = function (e, t, cb) {
    var n = this
      , r = e.rely
      , a = e.rowId;

    if (this.copyValue && 1 === t && e.widget.visible && e.widgetEnable || this.rely.isWidgetExclude(e.path, t, a))
      return this.fireWidgetRelyEvent(e, t);
    "location" === e.type && e.limitWidget && this.dealLocationLimitLink(e, t)
    if (r && r.formula) {
      var i = r.formula.formula
        , o = {};
      _.forEach(r.widgets, (function (e) {
        var t = null;
        let s1 = _._isSubformWidget(e);
        let s2 = _.isObjectEmpty(a);
        if (s1 && s2) {
          t = n.getFields(e);
        } else {
          t = n.getField(e, a);
        }
        // _._isSubformWidget(e) && _.isNil(a) ? n.getFields(e) : n.getField(e, a)
        if (_.isArray(t)) {
          var r = [];
          _.forEach(t, (function (e) {
            e && r.push(n.getLinkValue(e))
          }
          ))
          o[e] = r
        } else
          t && (o[e] = n.getLinkValue(t))
      }
      ));

      var l = !1;
      var u = this._calFormula(i, o, (function (t) {

        if (t && t.name && ['mapx', "recno", "map"].indexOf(t.name) > -1) {
          l = !0;
          n.rely.setErrorMap(!1, e.path, {
            name: t.name,
            rowIdx: e.rowIdx,
            msg: t.message,
          });
          // e.setValue("");
        }


        // t && t.message && ['mapx', "recno"].indexOf(t.message) > -1 && (l = !0,
        //   n.rely.setErrorMap(!1, e.path, t.message),
        //   e.setValue(""))
      }
      ));
      console.log(`dealRely _calFormula ${e.label} ${i} ${u}`);
      if (!l) {
        e.setValue(u);
        this.fireWidgetRelyEvent(e, t);
        this.rely.setErrorMap(!0, e.path, null)
      }
      // l || (e.setValue(u),
      //   this.fireWidgetRelyEvent(e, t),
      //   this.rely.setErrorMap(!0, e.path, null))
    }
    if (r && r.filter && r.data) {
      switch (e.type) {
        case "combo":
        case "combocheck":
          //2023 12 07  兼容老的模式，以前的模式，下拉框，在不可编辑的时候，会自动赋值给控件，
          //等下次改版 考虑其他写法优化掉
          // if (e.enable === false) {
          //   this.dealValueDataLink(e, t);
          // } else {

          if (r.data.relyMode == 2) {
            this.dealValueDataLink(e, t);
          } else {
            e.setValue(null);
            e.setLoadItems(null);
            this.fireWidgetRelyEvent(e, t);
          }


          // }

          break;
        case "dept":
        case "deptgroup":

          if (e.widget.valueOption === BsyConfig().WidgetValueOption.CUSTOM) {
            e.setLimit({});
            this.fireWidgetRelyEvent(e, t)
          } else {
            this.dealValueDataLink(e, t)
          }

          // e.widget.valueOption === k.$r.CUSTOM ? (e.setLimit({}),
          //   this.fireWidgetRelyEvent(e, t)) : this.dealValueDataLink(e, t);
          break;
        default:
          this.dealValueDataLink(e, t)
      }
    } else if (e.async) {
      switch (e.type) {
        case "combo":
        case "combocheck": {
          e.setLoadItems(null);
          this.fireWidgetRelyEvent(e, t);
          break
        }
        default:
          this.dealValueDataLink(e, t)
          break;
      }

    }


    if (t) this.getLinkQueryData(e);
    if (!r) {
      cb && cb();
    }
  }

  fireFixedRely = function (widgets) {

    let e = [];
    _.forEach(widgets, (widget) => {
      if (_._isSubformWidget(widget)) {
        let fs = this.getFields(widget);
        if (fs.length > 0) {
          e = e.concat(fs);
        }
      } else {
        let f = this.getField(widget)
        if (f) {
          e.push(f);
        }
      }
    })

    this.rely.fireDefaultRely(this, e);

  }

  dealRelys = function (widgets) {
    let that = this;
    let e = [];
    _.forEach(widgets, (widget) => {

      if (widget.indexOf('add') > -1) {
        var d = widget.split('-');
        _.forEach(that.fieldMap, (val, key) => {
          if (key.indexOf([d[0], d[2]].join('.')) > -1) {
            e.push(val);
          }
        })
      } else if (widget.indexOf('edit') > -1) {
        var d = widget.split('-');
        // getFieldIndex
        let el = that.getFieldIndex(d[0], d[2]);
        if (e) {
          e.push(el);
        }

      } else {
        if (_._isSubformWidget(widget)) {
          let fs = this.getFields(widget);
          if (fs.length > 0) {
            e = e.concat(fs);
          }
        } else {
          let f = this.getField(widget)
          if (f) {
            e.push(f);
          }
        }
      }

    })
    for (let index = 0; index < e.length; index++) {
      const element = e[index];
      that.dealRely(element, null, () => {
        that.fireWidgetRelyEvent(element, null);
      });
    }

  }

  fireSubformRowRely = function (e, t, n) {
    var r = this
      , a = []
      , i = [];
    _.forEach(e.items, (function (o) {
      var l = r.getField([e.name, o.widget.widgetName].join("."), t);
      l && (n && !['linkquery'].includes(o.widget.type) && o.widget.visible && o.widget.enable ? i.push(l) : a.push(l))
    }
    ))
    this.clearRelyCache();
    this.rely.fireRowRely(this, a, t, e, i);
    this.dealSubShowRules(e, t);
  }

  _isSubformWidget = function (a) {
    return a.indexOf(".") > -1
  }


  dealShowRules = function (e) {
    if (this.form) {

      if (this.form.setWidgetVisible) {
        this.form.setWidgetVisible(e);
      }

    }
    // this.form.dealShowRules(e.field)
  }

  dealSubShowRules = function (e, t) {
    if (this.form) {
      this.getViewVisibleMap();
      if (this.form.setWidgetVisible) {
        this.form.setWidgetVisible(e, t);
      }
    }
  }
  /**
   *
   * @param {*} e           触发的字段
   * @param {*} cb          数据加载，子表单导入使用，需要先触发完所有的扩展
   * @param {*} mode        数据加载，子表单导入 需要额外做特殊处理
   */
  fireEvent = function (e, cb, mode) {
    let that = this;


    var triggerFieldMode = e.extendSet ? e.extendSet.triggerFieldMode : '';
    var triggerField = e.extendSet ? e.extendSet.triggerField : '';
    var triggerFields = e.extendSet ? e.extendSet.triggerFields : '';
    this.triggerEvent(e, (relys) => {

      if (['import', 'dataload'].includes(mode)) {
        if (that.form) {
          that.getViewVisibleMap();
          that.form.setWidgetVisible && that.form.setWidgetVisible(null);
        }
        cb && cb();
        return
      }

      if (_.isNil(relys)) {
        cb && cb();
        return
      }

      if (that.form) {
        that.getViewVisibleMap();
        that.form.setWidgetVisible && that.form.setWidgetVisible(null);
      }

      switch (triggerFieldMode) {
        case "fixed": {
          if (triggerField) {
            // if (relys && !relys.includes(triggerField)) {
            //   that.dealRelys([triggerField]);
            // }
            that.dealRelys([triggerField]);
            // that.fireFixedRely([triggerField])
          }

          if (that.triggerControl) {
            that.dealRelys([that.triggerControl]);
            // that.fireFixedRely([that.triggerControl])
          }

          if (that.triggerWidget) {
            that.fireFixedRely([that.triggerWidget])
          }

          break;
        }
        case "multiple": {
          if (!BsyUtils.isObjectEmpty(triggerFields)) {
            that.dealRelys(triggerFields);
          }
          break;
        }
        case "all": {
          that.dealRelys(relys);
          // that.fireFixedRely(relys)
          break;
        }
        default: {
          if (that.triggerControl) {
            that.dealRelys([that.triggerControl]);
            // that.fireFixedRely([that.triggerControl])
          }

          if (that.triggerWidget) {
            that.fireFixedRely([that.triggerWidget])
          }
          break;
        }
      }

      cb && cb();
    }, mode)
  }

  fireWidgetRelyEvent = function (e, t) {
    var label = e.label;
    if (e.subform) {
      label = [e.subform.label || e.subform.labelStyle, [e.rowId, e.rowIdx].join('-'), e.label].join('.');
    }
    console.log(`\n\n\n------------- ${label} start -------------`)
    console.log(`------------- ${label} start -------------`)
    if (!t) {
      console.log(`------------- 手动触发 -------------`)
    }
    if (t) {
      //子表单的时候会有弹出层操作，需要响应
      if (e.subform) {
        if (this.form && this.form.onRelyDone) {
          this.form.onRelyDone(e.field, e.rowIdx)
        }

      }
    }
    var n = this;
    t || this.clearRelyCache()
    this.rely.fireRely(e, t, this);
    this.getViewVisibleMap();
    this.dealShowRules(e);
    this.dealSubShowRules(e);
    var r = this.getFieldPath(e);
    if (1 === t && this.delayLinkDataMap[r]) {
      _.forEach(this.delayLinkDataMap[r], (function (e) {
        n.getLinkData(e)
      }
      ));
      delete this.delayLinkDataMap[r]
    }

    // 1 === t && this.delayLinkDataMap[r] && (_.forEach(this.delayLinkDataMap[r], (function (e) {
    //   n.getLinkData(e)
    // }
    // )),
    //   delete this.delayLinkDataMap[r])
  }
  clearRelyCache = function () {
    this.relyCache = {};
    // this.formula.clearCache()
  }
  dealLocationLimitLink = function (e, t) {
    e.setValue({})
    this.fireWidgetRelyEvent(e, t);
    e.limitWidget && this.updateLocationLimitWidget(e);
    this.fireAutoPosition(e, t)
  }

  qB = () => {

  }

  updateLocationLimitWidget = function (e) {
    var t = _.get(this.getField(e.limitWidget), "value");
    e.updateRule({
      limits: this.qB(e.limitWidget, e.limitRadius, t)
    });
    e.setLimitWidgetValue(t);
    e.checkValidateImmediately(e.value)
  }
  syncLocationLimitWidgets = function () {
    var e = this;
    _.forEach(this.fieldMap, function (t) {
      "location" === t.type && t.limitWidget && t.widgetVisible && e.updateLocationLimitWidget(t)
    })
  }

  K = function (e) {
    if (e.mode === 'depend' && e.depend) {
      var t = e.depend
        , n = t.subform
        , r = t.subField
        , a = t.field;
      return n && r ? [n, r].join(".") : a
    }
    return null
  }
  Z = function (e) {
    return e.mode === 'depend' && e.depend ? e.depend.resultField : null
  }
  W = function (e, t) {
    var n = _.filter(e, (function (e) {
      return !function (e) {
        if (_.isObjectEmpty(e))
          return !0;
        if ([BsyConfig().CONST.FILTER_METHOD.EP, BsyConfig().CONST.FILTER_METHOD.NEP].indexOf(e.method) < 0)
          if (e.depend) {
            if (!e.depend.id)
              return !0
          } else {
            if (_.isObjectEmpty(e.value))
              return !0;
            var t = !0;
            if (_.forEach(e.value, (function (e) {
              if (!BsyUtils.isStringEmpty(e))
                return t = !1,
                  !1
            }
            )),
              t)
              return !0
          }
        return !1
      }(e)
    }
    ));
    return t === 'or' ? [true, n] : [true, n]
  }
  getRelyFilters = function (e) {
    var t = this
      , n = e.rely;
    if (!n || !n.filter || !n.filter.cond)
      return [];
    var r = [];
    _.forEach(n.filter.cond, (function (a) {
      var i, o = t.K(a);
      if (o) {
        var l;
        _._isSubformWidget(o) && e.isSubformWidget && (l = e.rowId);
        var u = t.getField(o, l);
        if (!u)
          return;
        var c = u.linkValue
          , s = t.Z(a);
        i = s ? {
          field: a.field,
          method: a.method,
          type: a.type,
          depend: {
            field: o,
            resultField: s,
            id: c
          }
        } : {
          field: a.field,
          method: a.method,
          type: a.type,
          value: t.formatRelyFilterValue(a.type, c, u)
        }
      } else
        i = {
          field: a.field,
          method: a.method,
          type: a.type,
          value: a.value
        };

      if (i) {
        _.merge(i, _.pick(i, ["field", "subform", "subField"]));
        i.entryId = _.get(n, "data.formId")
        r.push(i)
      }

      // i && (
      //   _.merge(i, _.pick(i, ["field", "subform", "subField"])),
      //   i.entryId = _.get(n, "data.formId"),
      //   r.push(i))
    }
    ))
    return r
  }
  formatRelyFilterValue = function (e, t, n) {
    var r;
    "datetime" === e
      ? r = _.isObjectEmpty(t)
        ? []
        : [BsyUtils.date2Str(t ? dayjsUtils.timeToTZ(t) : null, n.format || "yyyy-MM-dd HH:mm:ss")]
      : r = BsyUtils.makeArray(t);
    return r
  }

  q9t = () => {

  }

  dealValueDataLink = function (e, t) {

    var n, r = this, i = e.rely;
    if (i.data) {
      var o;
      o = _.has(this.rely.requestFieldsMap, e.path) ? _.merge({}, _.get(this.rely.requestFieldsMap, e.path), {
        formId: i.data.formId,
        refAppId: i.data.refAppId ? i.data.refAppId : this.form.options.appId,
        ...(["combocheck", "combo"].includes(e.type) ? {
          sortField: e.field.options?.async?.data?.sortField,
          sortMode: e.field.options?.async?.data?.sortMode,
          sortType: e.field.options?.async?.data?.sortType,
        } : {})
      }) : {
        widgets: [e.path],
        fields: [{
          field: i.data.field,
          subFields: i.data.subformField ? _.get(this.rely.subFieldsMap, e.path) : void 0
        }],
        formId: i.data.formId,
        refAppId: i.data.refAppId ? i.data.refAppId : this.form.options.appId,
        ...(["combocheck", "combo"].includes(e.type) ? {
          sortField: e.field.options?.async?.data?.sortField,
          sortMode: e.field.options?.async?.data?.sortMode,
          sortType: e.field.options?.async?.data?.sortType,
        } : {})
      };
      var filter = r._iterAddFilter(e, null)
      //console.log(`dealValueDataLink filter ${e.label} ${JSON.stringify(filter)}`)
      var l = this.getRelyFilters(e, null)
        , u = (null == (n = null == i ? void 0 : i.filter) ? void 0 : n.rel) || 'and'
        , c = r.W(l, u)
        , d = !BsyUtils.isObjectEmpty(filter);

      if (d) {
        var m = {
          cond: filter,
          rel: u
        }
          , p = BsyFormula.MD5(JSON.stringify({
            f: m,
            d: o
          }));
        // console.log(`dealValueDataLink /data/link hash ${p}`);
        _.merge(o, {
          appId: this.form.options.appId,
          entryId: this.form.options.entryId,
          dataId: this.form.options.dataId,
          subformName: e.subform ? e.subform.widgetName : null,
          subformField: e.type === 'subform' ? e.rely.data.subformField : null,
          widgetName: e.name,
          designAppId: this.form.options.refAppId || this.form.options.appId || window.FX.STATIC.APPID,
          designEntryId: this.form.options.formId || window.FX.STATIC.ENTRYID,
          rel: m.rel,
          field: e.rely.data.field,
          filter: filter,//r.filter2Old(m)

        })
        //console.log(`dealValueDataLink React.axios ${e.label} ${JSON.stringify(o)}`)
        // _.has(this.relyCache, p) || (this.relyCache[p] = React.axios("/data/link", o, {
        //   autoShowMsg: true
        // }).then((function (e) {
        //   return _.get(e, "data.data")
        // }
        // )));

        if (!_.has(this.relyCache, p)) {
          r.ajaxLoading = true;

          if (o.subformName) {
            const name = r.labelMap[[o.subformName, o.widgetName].join('.')]
            r.ajaxLoadingMsg = `「${name}」`; //this.labelMap
          } else {
            const name = r.labelMap[o.widgetName]
            r.ajaxLoadingMsg = `「${name}」`; //this.labelMap
          }

          this.relyCache[p] = React.axios("/data/link", o, {
            autoShowMsg: true
          }).then((function (e) {
            r.ajaxLoading = false;
            return _.get(e, "data.data")
          }
          ))
        }

        _.get(this.relyCache, p).then((function (n) {
          var a = _.get(n, i.data.field);
          if (r.rely.checkAsyncVersion(e, t)) {
            let o = r.dealSubformDataLink(e, a);
            r.setLinkValue(e, o, t);
            r.rely.setErrorMap(!0, e.path, null)
          } else {
            let o = r.dealSubformDataLink(e, a);
            r.setLinkValue(e, o, t);
            r.rely.releaseAsyncQue(e)
          }

        }
        ), (function (t) {
          var n = _.get(t, "data")
            , a = _.get(n, "code");
          r.ajaxLoading = false;
          if (a) {
            // r.rely.setErrorMap(!1, e.path, a);
            var msg = '';
            if ([400, 3000].indexOf(a) > -1) {
              msg = React.language("field.rely.request.error", {
                api: "/data/link",
                name: e.label,
                msg: n.msg,
                time: BsyUtils.date2Str(dayjsUtils.timeToTZ(new Date()), "yyyy-MM-dd HH:mm:ss")
              })
            } else {
              msg = n.msg;
            }
            tipAlert({
              msg: msg,
              type: "warning"
            })

            r.rely.setErrorMap(!1, e.path, {
              subformRow: e.rowIdx,
              code: n.code,
              msg: msg
            });

          } else {
            r.rely.setErrorMap(!1, e.path, _.get(t, "msg"))
          }
          r.rely.releaseAsyncQue(e);
          // r.trackDebounceDataLinkError(t);

          // a ? (r.rely.setErrorMap(!1, e.path, a),
          //   (0, I.q9t)([2010, 3e3, 4003, 2004], a) && r.setLinkErrorMessage(e)) : r.rely.setErrorMap(!1, e.path, _.get(t, "message")),
          //   r.rely.releaseAsyncQue(e),
          //   r.trackDebounceDataLinkError(t)
        }
        ))
      } else {
          r.setLinkValue(e, null, t)
          r.ajaxLoading = false;
      }
        // Promise.resolve().then((function () {
        //   r.setLinkValue(e, null, t)
        //   r.ajaxLoading = false;
        // }
        // ))
    }
  }
  setLinkValue = function (e, t, n) {
    var r = this;

    if ("subform" === e.type) {
      e.setValue(t, (function () {
        return r.fireWidgetRelyEvent(e, n)
      }
      ))
    } else {
      e.setValue(t);
      this.fireWidgetRelyEvent(e, n);
    }



    // "subform" === e.type ? e.setValue(t, (function () {
    //   return r.fireWidgetRelyEvent(e, n)
    // }
    // )) : (e.setValue(t),
    //   this.fireWidgetRelyEvent(e, n))
  }

  dealSubformDataLink = function (e, t) {
    var n = e.rely
      , r = e.type
      , a = t;
    if ("subform" === r && n) {
      a = [];
      var i = {};
      _.forEach(n.data.subformField, (function (e) {
        i[e.link] ? i[e.link].push(e.name) : i[e.link] = [e.name]
      }
      ))
      _.forEach(t, (function (e) {
        var t = {};
        _.forEach(e, (function (e, n) {
          i[n] && _.forEach(i[n], (function (n) {
            t[n] = e
          }
          ))
        }
        ))
        a.push(t)
      }
      ))
    }
    if ((r == "combocheck" || r == 'subform_combocheck') && n) {
      if (a && n.data.relyMode == 2) {
        if (!Array.isArray(a)) {
          a = [a];
        }
      }
    }
    if ((r == "combo" || r == 'subform_combo') && n) {
      if (a && n.data.relyMode == 2) {
        if (Array.isArray(a)) {
          if (a.length) {
            a = a[0];
          }
        }
      }
    }
    return a
  }
  getLinkQueryData = function (e) {
    this.form?._getLinkQueryData?.(e)
  }

  _iterAddFilter = function (b, c) {
    var d = this;
    if (b) {
      var e = b.rely;
      if (e && !e.data && b.async && b.async.data && b.async.data.filter) {
        let linkFilter = JSON.parse(JSON.stringify(b.async.data.filter))
        let refAppid = b.async.data.refAppid;
        let h = b.async.data.formId;
        if (!BsyUtils.isObjectEmpty(linkFilter) && !BsyUtils.isObjectEmpty(linkFilter.cond)) {
          let go = true;
          BsyUtils.forEach(linkFilter.cond, function (a, b1) {
            b1.form = (!refAppid || window.FX.STATIC.APPID === refAppid) ? h : [h, refAppid].join("@");
            if (b1.valueMode === 'depend') {
              let tt = [];
              BsyUtils.forEach(b1.value, function (k, name) {
                let d1 = d.getField(name, b.rowId);
                if (d1) {
                  let f = d1.getLinkValue();
                  if (f) {
                    let type = d1.type || d1.options.type
                    switch (type) {
                      case "datetime": {
                        let format = (d1 && d1.format) || 'yyyy-MM-dd'

                        let dc = dayjsUtils.timeToTZ(f);

                        if (dc != 'Invalid Date') {
                          f = BsyUtils.date2Str(dc, format)
                        } else {
                          f = null;
                        }
                        tt.push(f)
                        break;
                      }
                      case "user":
                      case "dept":
                        {
                          if (!BsyUtils.isObjectEmpty(f)) {
                            tt.push(f)
                          }
                          break;
                        }
                      case "usergroup":
                      case "deptgroup":
                        {
                          if (!BsyUtils.isObjectEmpty(f)) {
                            tt = tt.concat(f);
                          }
                          break;
                        }
                      case "linkdata": {
                        if (!BsyUtils.isObjectEmpty(f)) {
                          tt.push(f.key)
                        }
                        break;
                      }
                      default: {
                        if (BsyUtils.isArray(f)) {
                          tt = tt.concat(f);
                        } else {
                          tt.push(f)
                        }

                      }
                    }
                  }
                  else {
                    if (linkFilter.rel != 'or') {
                      go = !1
                    }
                    // TODO 修复时间范围只选一个是也会联动
                    if (tt.length) {
                      go = true
                    }
                    return !1;
                  }
                }
              })
              b1.value = tt;

            } else if (b1.valueMode === "custom") {
              b1.value = (b1.value || []).map(item => {
                // if (item === "100000000000000000000002") {
                //   return window.FX.STATIC?.user?._id;
                // }
                return item;
              });
            }

            if (b1.method !== "not_empty" && b1.method !== "empty") {
              if (BsyUtils.isObjectEmpty(b1.value)) {
                if (linkFilter.rel !== 'or') {
                  go = false;
                }
              }
            }

            // if(!BsyUtils.isObjectEmpty(b.value))
            // {
            //     dd.push(1);
            // }
          })
          return linkFilter;
        }
        return;
      }


      if (e && !e.ref) {
        return;
      }

      if (e && (c || (c = {}),
        !c[b.name])) {
        c[b.name] = !0;
        var f = {};
        var filter_is_null = false;
        e.data && e.ref && BsyUtils.forEach(e.widgets, function (g, h) {

          var l = null;

          if (h && h.indexOf("_widget_") > -1) {
            // if (c[h])
            //     return ;
            var i = -1;
            d._isSubformWidget(h) && (i = b.rowId);
            var j = d.getField(h, i);
            if (!j)
              return !1;
            // if (e.type && e.type[g])
            //   j.linkType = e.type[g].type;
            var k = j.getLinkValue();
            // if (j.getWidgetType() == 'linkdata') {
            //   if (k) {
            //     k = k.key
            //   }
            // }
            if (_.isObjectEmpty(k)) {
              if (e.data.rel === 'or') {
                filter_is_null = false;
                return
              } else {
                filter_is_null = true;
                return !1;
              }

            }

            //支持多条件 改进 2018.09.12
            if (BsyUtils.isString(e.ref.field))
              l = d._createDataFilter(j, k, e.ref.field);
            else if (_.isArray(e.ref.field))
              l = d._createDataFilter(j, k, e.ref.field[g],
                e.method ? e.method[g] : undefined);
          } else {
            var k1 = h ? h : "";
            var _const = null;
            var j1 = {};
            j1 = e.type[g];
            if (j1)
              j1.linkType = j1.type
            //处理常量值
            if (h === "fixed") {
              k1 = e.fixed && e.fixed[g];
            } else
              _const = h ? h : "";
            //支持多条件 改进 2018.09.12
            if (BsyUtils.isString(e.ref.field))
              l = d._createDataFilter(j1, k1, e.ref.field);
            else if (_.isArray(e.ref.field))
              l = d._createDataFilter(j1, k1, e.ref.field[g],
                e.method ? e.method[g] : undefined, _const);
            //处理常量值
          }
          //新的数据联动条件与 当前表与联动表的数据是反过来的
          if (e.hasOwnProperty("fixed")) {
            l[e.ref.field[g]].mode = "new";
          }

          //支持多条件 改进 2018.09.12
          if (!f[e.ref.formId]) {
            f[e.ref.formId] = [];
          }
          f[e.ref.formId].push(l); // = [l],
          //新版本 不执行默认递归
          if (!e.hasOwnProperty('version')) {
            var tempf = d._iterAddFilter(j, c);

            //这里为了处理联动条件 key值为一样的时候,联动条件会被覆盖的场景,使用了数组连接的模式
            //MT 18-9-14
            if (_.isArray(f[e.ref.formId])) {
              if (tempf && tempf[e.ref.formId] && _.isArray(tempf[e.ref.formId]))
                f[e.ref.formId] = f[e.ref.formId].concat(tempf[e.ref.formId]);
              //这里我们支持了多条件的场景,不知道是否会出现很多同样的条件,如果会对性能造成影响,可以在这里处理
              //MT
            } else
              window.$.extend(!0, f, tempf);
          }
        });
        if (filter_is_null)
          f = {};
        return f;
      }
    }
  }
  _createDataFilter = function (a, b, c, s, _const) {
    var d = {};
    var type = a.linkType || a.getLinkType && a.getLinkType() || a.type || 'text';
    switch (type) {
      case "datetime": {
        var format = (a && a.format) || 'yyyy-MM-dd'

        var e = [null];
        var f = b === 'today' ? dayjsUtils.timeToTZ(new Date()) : dayjsUtils.timeToTZ(b);
        if (f !== 'Invalid Date') {
          e = [BsyUtils.date2Str(f, format)]
        }

        d[c] = {
          widgetType: "datetime",
          orgWidgetType: type,
          widgetValue: e
        };
        break;
      }

      case "text":
      case "radiogroup":
      case "combo":
      case "textarea": {
        var h = b;
        _.isArray(b) || (h = [b])
        d[c] = {
          widgetType: "text",
          orgWidgetType: type,
          widgetValue: h
        };
        break;
      }

      case "user":
      case "usergroup":
      case "dept":
      case "deptgroup":
      case "combocheck":
      case "checkboxgroup": {
        var h = b;
        _.isArray(b) || (h = [b])
        d[c] = {
          widgetType: "check",
          orgWidgetType: type,
          widgetValue: h
        };
        break;
      }

      // case "dept": {
      //   var h = b;
      //   _.isArray(b) || (h = [b])
      //   d[c] = {
      //     widgetType: "dept",
      //     orgWidgetType: type,
      //     widgetValue: h
      //   };
      //   break;
      // }

      // case "user": {
      //   var h = b;
      //   _.isArray(b) || (h = [b])
      //   d[c] = {
      //     widgetType: "user",
      //     orgWidgetType: type,
      //     widgetValue: h
      //   };
      //   break;
      // }

      case "address": {
        var h = b;
        _.isArray(b) || (h = [b])
        d[c] = {
          widgetType: "address",
          orgWidgetType: type,
          widgetValue: h
        };
        break;
      }

      default: {
        var h = b;
        _.isArray(b) || (h = [b])
        d[c] = {
          widgetType: "combocheck",
          orgWidgetType: type,
          widgetValue: h
        };
        break;
      }
    }
    if (s)
      d[c].method = s;
    if (_const)
      d[c].const = _const;

    return d
  }


  _calGetValue = (type, data) => {
    switch (type) {
      case "address":
      case "location":
      case "subform_address":
      case "subform_location": {
        if (!_.isObjectEmpty(data)) {
          return JSON.stringify(data) //BsyUtils.address2Str(data, "", "pcda");
        }
        return "";
      }
      case "dept":
      case "user": {
        if (data) {
          if (_.isString(data)) {
            if (window[`${type}SelectMap`]) {
              return window[`${type}SelectMap`][data] ? window[`${type}SelectMap`][data].name || window[`${type}SelectMap`][data].nickname : data;
            }
          } else {
            return data?.nickname
          }
        }
        return "";
      }
      case "deptgroup":
      case "usergroup": {

        let val = []
        if (_.isArray(data)) {

          BsyUtils.forEach(data, function (a1, b1) {
            var name = "";
            if (b1) {
              if (_.isString(b1)) {
                if (type === 'usergroup') {
                  name = window[`userSelectMap`][b1] ? window[`userSelectMap`][b1].name || window[`userSelectMap`][b1].nickname : b1;
                } else {
                  name = window[`deptSelectMap`][b1] ? window[`deptSelectMap`][b1].name || window[`deptSelectMap`][b1].nickname : b1;
                }
              } else {
                name = b1.nickname
              }
            }
            val.push(name);
          })
        }
        return val;
      }


      default: {

        break;
      }

    }
    return data;
  }

  _calFormula = function (a, b, cb) {
    var c = this,
      d = a.split(/(\$[0-9a-zA-Z._#@]+)/g),
      e = []

    BsyUtils.forEach(d, function (a, d) {
      if (BsyUtils.startWith(d, "$_widget_") || BsyUtils.startWith(d, "$ext")) {
        let f = d.replace("$", "").split("#"),
          g = f[0],
          h = f[1];
        if (BsyUtils.isEmpty(h)) {
          let i;
          if (b) {
            let j = _._isSubformWidget(g) ? c.getFields(g) : c.getField(g);
            if (_.isArray(j)) {
              j = j[0];
            }

            if (j) {
              let data = b[g];
              i = c._calGetValue(j.type, data)
            } else {
              if (_._isSubformWidget(g)) {
                i = [];
              }
            }
          } else {
            let j = _._isSubformWidget(g) ? c.getFields(g) : c.getField(g);

            if (_.isArray(j)) {
              i = []
              BsyUtils.forEach(j, function (a, b) {
                i.push(c._calGetValue(j.type, b.getLinkValue()))
              })
            } else {
              j && (i = c._calGetValue(j.type, j.getLinkValue()))
            }
          }
          if (_.isNil(i)) i = null;
          var k = JSON.stringify(i);
          k = (k = (k = k.replace(/\\\\(?=.+)/g, '"+CHAR(92)+"')).replace(/\\\"(?=.+)/g, '"+CHAR(34)+"')).replace(/\\n(?=.+)/g, '"+CHAR(10)+"')
          !isNaN(i) && i < 0 && (k = "(" + k + ")")
          e.push(k)
        } else
          e.push('"' + d + '"')
      } else
        e.push(d)
    });
    var f;
    try {
      var str = e.join("")

      console.log(`_calFormula ${1}\t| formula -> ${str}\n`);
      f = BsyFormulaCalcParser.parse(str)
      // f = BsyUtils.evalFormula(e.join(""))
    } catch (err) {
      if (err instanceof customError) {
        console.log("Name:", err.name); // 输出: CustomErrorName
        console.log("Message:", err.message);
        cb && cb({
          message: err.message,
          name: err.name
        })
      } else {
        console.error(err);
        cb && cb(err)
      }
      // console.error(err);

      f = ""
    }
    return f
  }

  eventGetValue = () => {
    let b = this
      , c = {}
      , d = b.form.options.resultWidgets;
    this.checkRepeat = [];
    for (let e in d) {
      let f = d[e];
      if (f && BsyUtils.isValueWidget(f.getWidgetType())) {
        let g = f.getValue();
        if (f.options.type === 'number' || f.options.type === 'subform') {
          g = f.getText();
          if (f.options.type === 'number' && g === "") {
            g = null;
          }
        } else if (f.options.type == 'combocheck') {
          if (BsyUtils.isString(g)) {
            if (g.length === 0) {
              g = null
            } else {
              g = [g]
            }
          }
        }
        let isVisible = f.isVisible();
        if (isVisible && b.showRules && b.showRules.hasOwnProperty(e)) {
          isVisible = b.showRules[e];
        }
        //字段可见，然后所在的标签页是否可见，不可见则忽略
        let tab = f.getTabName()
        if (isVisible && tab) {
          if (b.showRules && b.showRules.hasOwnProperty(tab)) {
            if (b.showRules[tab] === false) {
              isVisible = false;
            }
          }
        }
        if (isVisible && this.dataTable) {
          isVisible = this.dataTable.getWidgetVisible(e)
        }
        if (b.ignoreAuth) {
          isVisible = true;
        }

        c[e] = {
          data: g,
          visible: isVisible,
        }
      }
    }

    return c
  }

  getValue = () => {
    let b = this
      , c = {}
      , d = b.form.options.resultWidgets;
    this.checkRepeat = [];
    for (let e in d) {
      let f = d[e];
      if (f && BsyUtils.isValueWidget(f.getWidgetType())) {

        let isVisible = f.isVisible();
        if (isVisible && b.showRules && b.showRules.hasOwnProperty(e)) {
          isVisible = b.showRules[e];
        }
        //字段可见，然后所在的标签页是否可见，不可见则忽略
        let tab = f.getTabName()
        if (isVisible && tab) {
          if (b.showRules && b.showRules.hasOwnProperty(tab)) {
            if (b.showRules[tab] === false) {
              isVisible = false;
            }
          }
        }
        if (isVisible && this.dataTable) {
          isVisible = this.dataTable.getWidgetVisible(e)
        }
        if (b.ignoreAuth) {
          isVisible = true;
        }

        let g = f.getValue();
        if (f.options.type === 'number' || f.options.type === 'subform') {
          g = f.getText();
          if (f.options.type === 'number' && g === "") {
            g = null;
          }
        } else if (f.options.type == 'combocheck') {
          if (BsyUtils.isString(g)) {
            if (g.length === 0) {
              g = null
            } else {
              g = [g]
            }
          }
        }
        if (f.options.noRepeat && !BsyUtils.isEmpty(g)) {
          let h = {};
          h[f.options.widgetName] = g;
          b.checkRepeat.push(h);
        }
        if (f.options.type == 'subform' && !BsyUtils.isEmpty(g)) {
          let items = f.options.items, noRepeatArr = {}, noRepeatValue = {};
          if (!BsyUtils.isEmpty(items)) {
            BsyUtils.forEach(items, function (key, value) {
              if (value.widget.noRepeat) {
                noRepeatArr[[f.options.widgetName, value.widget.widgetName].join(".")] = 1;
              }
            })
          }

          BsyUtils.forEach(g, function (key, value) {
            !BsyUtils.isEmpty(value) && BsyUtils.forEach(value, function (skey, svalue) {
              let subname = [f.options.widgetName, skey].join(".");
              if (svalue.data != undefined && noRepeatArr[subname]) {
                noRepeatValue[subname] ? noRepeatValue[subname].push(svalue.data) : noRepeatValue[subname] = [svalue.data];
              }
            })
          })
          !BsyUtils.isObjectEmpty(noRepeatValue) && b.checkRepeat.push(noRepeatValue);
        }



        c[e] = {
          data: g,
          visible: isVisible,
        }
      }
    }

    return c
  }

  onResetRel = (t) => {
    if (this.pupupDashContext && this.pupupDashContext.setRel)
      this.pupupDashContext.setRel(t);
  }

  onResetFilter = () => {
    this.pupupDashContext.ResetFilter();
  }

  getPupupDashContext = (content) => {
    this.pupupDashContext = content;
  }

  buttonEvent = (field, event, callback) => {

    let that = this;

    if (this.mode == 'preview') {
      tipAlert({
        type: "warning",
        msg: React.language("preview.buttom.triggerEvent")
      })
      return
    }

    if (field) {
      if (field.mode == "popupreport" || (field.extendSet && field.extendSet.funMode == "popupreport")) {
        console.log('弹报表')
        this._popupreport(field);
      }
      else if (field.mode == "popupform" || (field.extendSet && field.extendSet.funMode == "popupform")) {
        console.log('弹表单')
        this._popupform(field, callback);
      }
      else if (field.mode == "print" || (field.extendSet && field.extendSet.funMode == "print")) {
        console.log('打印')
        this._buttonPrint(field, event);
      }
      else if (field.mode == "popuppage" || (field.extendSet && field.extendSet.funMode == "popuppage")) {
        console.log('外部网页')
        this._popuppage(field);
      }
      else if (field.funMode == "module" || field.funMode == "all" || field.funMode == "event" || field.funMode == "datahelp" || field.funMode == "formEvent" || (field.extendSet && (field.extendSet.funMode == "module" || field.extendSet.funMode == "event" || field.extendSet.funMode == "datahelp" || field.extendSet.funMode == "formEvent" || field.extendSet.funMode == "all"))) {
        that.fireEvent(field, () => { })
      }
    }
  }

  _popupreport = (el) => {

    let _this = this;
    let opt = { ...el.field.options, ...el.field.options.extendSet }
    if (!opt.reportId) {
      return
    }
    if (opt.hasOwnProperty('reportarg'))
      opt.arg = opt.reportarg;
    let subform = null;
    let subformvalindex = -1;
    if (opt.subform) {
      subform = el.subform.widgetName;
      subformvalindex = el.rowIdx;
    }
    let val = _this.getValue();
    let rowdata = {};
    BsyUtils.forEach(val, function (a1, b1) {
      if (b1) {
        if (a1 == subform) {
          let subval = b1.data[subformvalindex];
          if (subval) {
            BsyUtils.forEach(subval, function (a2, b2) {
              rowdata[[a1, a2].join(".")] = b2.data;
            })
          }
        }
        else {
          rowdata[a1] = b1.data;
        }
      }
    })

    window.FX.Utils.dataAjax({
      url: "/dashboard/app/" + _this.appId + "/entry/" + (opt.reportId || opt.formId),
      data: {
        popupFormPath: _this.popupFormPath
      }
    }, function (f) {

      let h = f.entry;
      BsyUtils.forEach(h.components, (key, value) => {
        if (BsyUtils.isObjectEmpty(value)) {
          delete h.components[key];
        }
      })
      window.FX.Utils._filterDefaultReplace(h, opt, rowdata);
      const allComponentDash = _.cloneDeep({ ...f, entry: h, appId: _this.appId, formId: _this.formId, entryId: _this.entryId })

      let rel = h.rel || 'and';
      var cddashConfig = Object.fromEntries(Object.entries(h.components).filter(([, val]) => {
        return !val['parentsId']
      }))
      h.components = cddashConfig

      let rootTokenDashClass = 'rootTokenDashClass' + _this.appId + opt.reportId + 'popup' + window.FX.STATIC.zIndex++
      BsySlidePane({
        title: h.name,
        onHeaderMenu: () => {
          return <div className="slide-dash-menu">

            {
              h.showFilter ? <>

                <div className="dash-filter-rel"
                  data-tip={rel === 'and' ? React.language('reset.filter.and.tip') : React.language('reset.filter.or.tip')} data-place={"bottom"} data-type={window.mode} data-html={true}
                >

                  <BsySelect
                    allowBlank={false}
                    searchable={false}
                    value={rel}
                    items={[
                      { value: "and", text: React.language('filter.rel.and'), },
                      { value: "or", text: React.language('filter.rel.or'), }]}
                    onStopEdit={(val) => {
                      _this.onResetRel(val)
                    }}
                  />

                </div>
              </>
                : ''
            }
            {
              h.cacheFilter ? <>
                <div
                  data-tip={React.language('reset.filter')} data-place={"bottom"} data-type={window.mode} data-html={true}
                  className="dash-filter-reset" onClick={_this.onResetFilter}><i className={"icon-async"} /><span>{React.language('richtext.reset')}</span></div></>
                : ''
            }
          </div>
        },
        onContentCreate: () => {

          return <BsyDashContainer
            {...{
              ...h,
              appId: h.appId,
              entryId: h.entryId,
              showType: 'popup',
              popupFormPath: _this.popupFormPath.concat({
                appId: _this.appId,
                formId: _this.formId,
                entryId: _this.formId,
                dataId: _this.form.options.dataId,
                subform: el.field.options.subform,
                flowId: _this.form.options.flowId,
                flowType: _this.form.options.flowType,
                widgetName: el.name,
              })
            }}
            allComponentDash={allComponentDash}
            rel={rel}
            rootTokenDashClass={rootTokenDashClass}
            getContext={_this.getPupupDashContext}
            prefix={'tablepopu'}
          />
        },
        onClose: () => {
          let d = document.getElementById(rootTokenDashClass);
          if (d) {
            d.remove();
          }
        }
      })
    })
  }

  _popupform = (el) => {

    let _this = this;

    let opt = { ...el.field.options, ...el.field.options.extendSet }
    let subform = null;
    let subformvalindex = -1;
    let type = 'normal';

    let val = _this.getValue();
    let extendSet = el.field.options.extendSet;
    if (BsyUtils.isObjectEmpty(extendSet)) {
      return;
    }
    if (BsyUtils.isObjectEmpty(extendSet.formId)) {
      return;
    }

    if (el.subform) {
      subformvalindex = el.rowIdx;
      subform = el.subform.name;
      type = 'sub';
    }
    let appId = _this.appId;
    let entryId = _this.formId || _this.entryId;
    let formId = _this.formId || _this.entryId;
    if (formId.indexOf('@') > -1) {
      let ds = formId.split("@");
      appId = ds[1];
      formId = ds[0];
      entryId = ds[0];
    }

    let popupFormPath = _this.popupFormPath.concat({

      flowId: _this.form.options.flowId,
      flowType: _this.form.options.flowType,
      dataId: _this.form.options.dataId,
      appId: _this.appId,
      formId: _this.formId,
      entryId: _this.formId,
      subform: el.field.options.subform,
      widgetName: el.name,
    });

    React.axios("/data/formtablemenu", {
      appId: appId,
      entryId: entryId,
      formId: entryId,
      dataId: _this.form.options.dataId,
      pupupFormId: opt.formId, //数据来源的id   如果是跨 应用的 按照 @的类型来  53cf7491f2cda6ede7cd7c57@5edf010e013952f2fe30b139
      type: type, //类型 弹出表单
      widgetName: opt.widgetName,
      data: val,
      index: subformvalindex,
      subformName: opt.subform,
      popupFormPath: popupFormPath,
    })
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          _this.creatForm(res, opt, popupFormPath);
        }, () => {

        })
      })


  }

  creatForm = (res, opt, popupFormPath) => {
    let that = this;

    const h = res ? res.data.entry : {};

    const { restore } = BsyUtils.globalIdManager(
      h.appId,
      h.entryId,
      null,
      h._id
    );

    window.FX.STATIC.INNERLINK = h._id;

    if (!BsyUtils.isObjectEmpty(h.href)) {
      window.FX.STATIC.FORMHREF = h.href;
    }
    else {
      window.FX.STATIC.FORMHREF = null
    }

    let formConfig = {
      ...h,
      appId: h.appId,
      entryId: h.entryId,
      onWriteBackForm: (data) => {
        that._writeBackFrom(data, opt.popupformwritebackarg);
        restore();
        window.FX.STATIC.FORMHREF = null;
      }
    }
    formConfig.content.width = '80%';
    formConfig.content.name = h.name;
    formConfig.content.eventType = 'popupform';

    let layerRef = null;
    BsyMaskLayer({
      customCls: 'fadein-right',
      onContentCreate: (ref) => {
        layerRef = ref;
        return <BsyFormPane
          hasHeader={true}
          {...{
            popupFormPath: popupFormPath
          }}
          formConfig={formConfig}
          mode={"new"}
          onClose={() => {
            restore();
            layerRef && layerRef.close();
          }}
        />
      }
    })
  }

  _writeBackFrom = (value, arg) => {

    var _this = this;
    BsyUtils.forEach(arg, function (argindex, item) {
      var widget = _this.getField(item.field);
      if (!widget) //字段被删除不回写
        return
      if (item.mode === "custom") {
        widget.setValue(item.value);
      } else if (item.mode === "currentUser") {
        widget.setValue(window.FX.STATIC?.user?._id);
      } else {
        if (item.depend && item.depend.field) {
          if (value[item.depend.field]) {
            widget.setValue(value[item.depend.field])
          }
          else {
            widget.setValue(null);
          }
        }
      }
      _this.fireWidgetRelyEvent(widget, null);
    })
  }

  _popuppage = (el) => {
    var _this = this;

    let opt = { ...el.field.options, ...el.field.options.extendSet }
    var subform = null;
    var subformvalindex = -1;
    var type = 'normal';
    if (el.subform) {
      subformvalindex = el.rowIdx;
      type = 'sub';
      subform = el.subform.name;
    }
    var val = _this.getValue();
    if (window.FX.STATIC.FTOKEN) {

      BsySlidePane({
        title: opt.webTitle ? opt.webTitle : React.language('widget.web.page'),
        hasHeader: true,
        onContentCreate: (ref) => {
          return _this.createWebPage({}, opt, val, subformvalindex, ref)
        },
      })
    } else {
      if (opt.webUrl) {
        window.FX.Utils.ajax({
          url: "/data/getCurrentUserInfo",
          data: {
            appId: _this.appId,
          }
        }, function (res) {
          BsySlidePane({
            title: opt.webTitle ? opt.webTitle : React.language('widget.web.page'),
            hasHeader: true,
            onContentCreate: (ref) => {
              return _this.createWebPage(res.data, opt, val, subformvalindex, ref)
            },
          })
        })
      }
    }
  }
  getWebFieldValue = (res, val, subformvalindex, opt) => {
    var lineValue;
    if (!val) {
      return ""
    }
    if (subformvalindex > -1) {
      if (opt.subform === res.name.split('.')[0]) {
        if (val[opt.subform].data.length > 0) {
          lineValue = val[opt.subform].data[subformvalindex][res.name.split('.')[1]].data;
        } else {
          lineValue = ""
        }
      }
    } else {
      if (res.name.indexOf('.') > -1) {
        if (val[res.name.split('.')[0]]) {
          lineValue = val[res.name.split('.')[0]].data;
        } else {
          lineValue = "";
        }
      } else {
        if (val[res.name]) {
          lineValue = val[res.name].data;
        } else {
          lineValue = "";
        }
      }
    }

    if (!lineValue && lineValue !== 0) {
      return '';
    }

    switch (res.type) {
      case "checkboxgroup":
      case "combocheck":
      case "array":
      case "radiogroup":
      case "combo":
      case "string":
      case "text":
      case "id":
      case "did":
      case "dept":
      case "user":
      case "usergroup":
      case "deptgroup":
        if (BsyUtils.isArray(lineValue)) {
          lineValue = lineValue.join('、');
        } else {
          lineValue = lineValue;
        }
        break;
      case "formula":
      case "number":
        lineValue = BsyUtils.num2Str(lineValue, res.format);
        lineValue = lineValue;
        break;
      case "flowState": {
        switch (parseInt(lineValue)) {
          case window.FX.CONST.WORKFLOW.FLOWSTATE.INPROCESS:
            lineValue = React.language("flow.state.inProcess")
            break;
          case window.FX.CONST.WORKFLOW.FLOWSTATE.COMPLETE:
            lineValue = React.language("flow.node.end")
            break;
          case window.FX.CONST.WORKFLOW.FLOWSTATE.CLOSE:
            lineValue = React.language("flow.state.closed")
            break;
          default:
            lineValue = '';
        }
        break;
      }
      case "address":
      case "location":
        var l = [];
        var e = lineValue;
        if (e.province) {
          l.push(e.province);
          e.city && e.province !== e.city && l.push(e.city);
          e.district && l.push(e.district)
        }
        if (e.detail) {
          l.push(e.detail)
        }
        lineValue = BsyUtils.address2Str(e, e.format || "pcda");
        lineValue = lineValue;
        break;
      case "lat":
        var e = val[res.name.split('.')[0]].data;
        lineValue = e.lnglatXY ? e.lnglatXY[1] : '';
        break;
      case "lng":
        var e = val[res.name.split('.')[0]].data;
        lineValue = e.lnglatXY ? e.lnglatXY[0] : '';
        break;
      case "datetime":
        if (lineValue) {
          // lineValue = BsyUtils.date2Str(new Date(lineValue), field.format || 'yyyy-MM-dd');
          lineValue = lineValue
        }
        break;
      case "linkdata":
        var e = lineValue;
        var d = e && e.key;
        if (BsyUtils.isNull(d)) {
          lineValue = ''
          break;
        }
        "datetime" === res.linkType ? lineValue = BsyUtils.date2Str(new Date(d), "yyyy-MM-dd") : lineValue = d;
        lineValue = lineValue;
        break;
      default:
        lineValue = lineValue;
        break;
    }

    return lineValue;
  }

  createWebPage = (webParameterList, opt, val, subformvalindex, ref) => {
    var i = opt
      , e = this
      , webUrl = ''
      , suffix = '';
    BsyUtils.forEach(i.suffixField, function (key, res) {
      if (encodeURIComponent(e.getWebFieldValue(res, val, subformvalindex, opt)) === "") {
        return;
      }
      suffix += ('/' + encodeURIComponent(e.getWebFieldValue(res, val, subformvalindex, opt)));
    })
    BsyUtils.forEach(i.webParameter, function (key, res) {
      var sym = ''
      if (key !== 0) {
        sym = '&'
      }
      switch (res) {
        case 'webpage_corp_id':
          webUrl += sym + 'webpage_corp_id=' + encodeURIComponent(webParameterList.corp_id);
          break;
        case 'webpage_user_id':
          webUrl += sym + 'webpage_user_id=' + encodeURIComponent(webParameterList.user_id);
          break;
        case 'webpage_phone':
          webUrl += sym + 'webpage_phone=' + encodeURIComponent(webParameterList.mobile);
          break;
        case 'webpage_account':
          webUrl += sym + 'webpage_account=' + encodeURIComponent(webParameterList.account);
          break;
        case 'webpage_email':
          webUrl += sym + 'webpage_email=' + encodeURIComponent(webParameterList.email);
          break;
        case 'webpage_corp_user_id':
          webUrl += sym + 'webpage_corp_user_id=' + encodeURIComponent(webParameterList.uniqueid);
          break;
        default:
      }
    })

    BsyUtils.forEach(i.webField, function (key, res) {
      var sym = ''
      if (webUrl) {
        sym = '&'
      } else {
        if (key !== 0) {
          sym = '&'
        }
      }

      if (encodeURIComponent(e.getWebFieldValue(res, val, subformvalindex, opt)) === "") {
        return;
      }
      webUrl += sym + res.key + '=' + encodeURIComponent(e.getWebFieldValue(res, val, subformvalindex, opt));
    })


    if (i.webUrl.indexOf('?') > -1) {
      var urlList = i.webUrl.split('?');
      webUrl = urlList[0] + suffix + '?' + webUrl + '&' + urlList[1]
    } else {
      webUrl = i.webUrl + suffix + '?' + webUrl
    }

    if (i.otherWebConfig && i.otherWebConfig.indexOf("open_new_page") > -1) {
      ref && ref.closeAlter();
      window.open(webUrl)
    } else {
      return <iframe src={webUrl}
        title={opt.webTitle ? opt.webTitle : React.language('widget.web.page')}
        style={{
          display: 'block',
          width: '100%',
          height: '100%'
        }}
        frameborder={"0"}
      />
    }


    // $('<iframe style="display: block;" frameborder="0" width="100%" height="100%"/>').attr('src', webUrl);
  }


  _doPrint = (print, cb) => {
    var b = this

    if (!this.isPrinting) {

      this.isPrinting = !0;
      var d1 = BsyUtils.checkRefApp({
        appId: this.appId,
        entryId: this.entryId,
        formId: this.formId,
      });

      let layerRef = null;
      BsyMaskLayer({
        customCls: 'sloading',
        onContentCreate: (ref) => {
          layerRef = ref;
          return <BsySLoading />
        }
      })

      window.FX.Utils.dataAjax({
        url: "/data/button_print",
        data: {
          scenes: "button",
          appId: d1.appId,
          dataId: this.dataId,
          entryId: d1.entryId,
          formId: d1.formId || d1.entryId,
          data: b.getValue(),
          printId: print,
        }
      }, function (c) {
        layerRef && layerRef.close()
        layerRef = null;
        b.isPrinting = false;
        cb && cb(c);

      }, null, function () {
        b.isPrinting = !1;
        layerRef && layerRef.close()
        layerRef = null;
      })
    }
  }

  _buttonPrint = (widget, event) => {

    let that = this;

    if (!widget.field.options.extendSet) return;
    let config = { ...widget.field.options.extendSet.print };
    let ptlist = [];
    BsyUtils.forEach(config.print, function (a1, b1) {
      ptlist.push({
        printId: a1,
        name: b1.name,
      })
    })

    if (BsyUtils.isObjectEmpty(ptlist)) {
      tipAlert({
        msg: React.language("flow.list.multiNode22"),
        type: "warning"
      });
      return
    }
    let _this = this;
    // let _opt = this.options;

    if (ptlist.length == 1) {
      if (!doVerify()) {
        return;
      }

      _this._doPrint(ptlist[0].printId, function (result) {
        showpdf(result);
      })
    }
    else {

      let menu = [];
      BsyUtils.forEach(ptlist, (a1, b1) => {
        menu.push({
          text: b1.name,
          colorType: "",
          icon: "",
          click: () => {
            if (!doVerify()) {
              return;
            }

            _this._doPrint(b1.printId, function (result) {
              showpdf(result);
            })
          }
        })
      })

      let currentTarget = event.currentTarget || BsyUtils.closestClass(event.target, 'BsyBtn')

      BsyAlertMenu({
        item: menu,
        width: 220,
        // height: 210,
        position: {
          top: event.clientY,
          left: event.clientX,
        },
        target: currentTarget,
        onClose: () => {

        }
      })

    }

    //验证字段规则
    function doVerify() {

      let result = !0
      let n = null;

      //忽略数据管理
      // if (that.ignoreAuth) {
      //     return result;
      // }

      that.getViewVisibleMap();

      if (!config.validator) {
        return result;
      }

      if (BsyUtils.isObjectEmpty(config.validatorWidget)) {
        return result;
      }
      let validatorWidget = [];
      BsyUtils.forEach(config.validatorWidget, function (a1, b1) {
        if (b1.indexOf(".") > -1) {
          let bb = b1.split(".");
          if (validatorWidget.indexOf(bb[0]) == -1) {
            validatorWidget.push(bb[0]);
          }
        }
        validatorWidget.push(b1);
      })

      let d = that.form.options.resultWidgets;
      for (let e in d) {
        if (validatorWidget.indexOf(e) > -1) {
          let f = d[e];
          let isVisible = f.isVisible();
          if (isVisible && that.showRules && that.showRules.hasOwnProperty(e)) {
            isVisible = that.showRules[e];
          }
          //字段可见，然后所在的标签页是否可见，不可见则忽略
          let tab = f.getTabName()
          if (isVisible && tab) {
            if (that.showRules && that.showRules.hasOwnProperty(tab)) {
              if (that.showRules[tab] === false) {
                isVisible = false;
              }
            }
          }
          if (isVisible) {
            // _this.clearErrorState(f);
            if (f.getWidgetType() == "subform") {

              let subvalidatorWidget = [];
              BsyUtils.forEach(validatorWidget, function (a1, b1) {
                if (b1.indexOf(".") > -1) {
                  let bb = b1.split(".");
                  if (bb[0] == f.getWidgetName()) {
                    subvalidatorWidget.push(b1);
                  }
                }
              })

              if (!f.checkValidate(config.validatorWidget)) {
                let errorWidgets = f.getErrorWidgets();

                if (!that.dataTable) {
                  that.onWidgetError({
                    name: f.getWidgetName(),
                    type: f.getWidgetType(),
                    errs: errorWidgets,
                    errMsg: f.getInvalidateTypeText(),
                  })
                } else {
                  BsyUtils.forEach(errorWidgets, (index, widget) => {
                    let widgetElement1 = that.form.getCurrentFieldElement(widget.name, widget.idx);
                    if (widgetElement1) {
                      that.dataTable.renderErrorTip(widgetElement1, widget.errMsg);
                    }
                  })
                }
                result = !1;
                n = n || f
              }
            }
            else {
              if (!f.checkValidate()) {


                if (!that.dataTable) {
                  if (that.onWidgetError) {
                    that.onWidgetError({
                      name: f.getWidgetName(),
                      type: f.getWidgetType(),
                      errMsg: f.getInvalidateTypeText(),
                    })
                  }
                } else {
                  let widgetElement = that.form.getCurrentFieldElement(f.getWidgetName(), 0);
                  if (widgetElement) {
                    this.dataTable.renderErrorTip(widgetElement, f.getInvalidateTypeText());
                  }
                }
                result = !1;
                // _this.setErrorState(f);
                n = n || f
              }
            }
          }
        }
      }
      // if (!result && n) {
      //     _this.scrollInvalidWidgetToView(n);
      // }
      return result;
    }

    function setpdf(c) {
      let field = _this.getField(config.bindWidget)
      if (field) {
        let tmpval = field.getValue();
        if (field.maxFileCount == 1 || BsyUtils.isObjectEmpty(tmpval)) {
          tmpval = [];
        }
        tmpval.push(c.file);
        field.setValue(tmpval);
        that.getViewVisibleMap();
        that.dealShowRules(field);
        that.dealSubShowRules(field);
        // that.setFieldValue(config.bindWidget, tmpval)
      }
    }

    function showpdf(c) {
      var routUrl = window.root_directroy ? window.root_directroy + '/' : '';
      let url = '';
      let downloadUrl = '';
      switch (window.FX.CONST.QN_BUCKET.UPLOAD_SITE) {
        case "minio":
        case "qcloud":
        case 'qn': {
          url = c.file.originalUrl;
          downloadUrl = c.file.downloadUrl;
          break;
        }

        case 'localftp':
        case 'aliyun':
        case 'huawei': {
          url = window.FX.CONFIG.HOST.IMAGE_HOST + "/" + c.file.qnKey;
          downloadUrl = window._bby_config.site + routUrl + 'file/get/' + c.file.qnKey + '?filename=' + encodeURIComponent(c.file.name)
          break;
        }
        default: {
          url = window.FX.CONFIG.HOST.IMAGE_HOST + "/" + c.file.qnKey;
          downloadUrl = window.FX.CONFIG.HOST.IMAGE_HOST + "/" + c.file.qnKey + "?attname=" + c.file.name
        }
      }

      if (!config.saveWidget) {

        if (BsyUtils.isDingdingBrowser()) {
          window.FX.Utils.dataAjax({
            url: "/sso/getJumpUrl",
            data: {
              url: url
            }
          }, function (data) {
            BsyUtils.redirectTo(data.url, "_blank");
          }, null);
          return;
        }
        popup(c, url, downloadUrl)
        // let title = "";
        // if (c.file.name.indexOf("docx") > -1) {
        //   title = React.language("data.word");
        // } else {
        //   title = React.language("data.pdf");
        // }

        // BsySlidePane({
        //   title: title,
        //   hasHeader: true,
        //   onContentCreate: (ref) => {
        //     if (c.file.name.indexOf("docx") > -1) {

        //       var obj = c.file;


        //       var rets = "url=" + encodeURIComponent(downloadUrl);
        //       rets += "&mime=" + encodeURIComponent(obj.mime);
        //       rets += "&name=" + encodeURIComponent(obj.name);
        //       rets += "&key=" + encodeURIComponent(obj.qnKey);
        //       rets += "&size=" + encodeURIComponent(obj.size);

        //       var src = "https://" + (window._bby_config.office_domain || 'office.baibaoyun.com') + "/op/view.aspx?" + rets;

        //       return <iframe title={c.file.name} name={c.file.name}
        //         className="file-box-preview"
        //         frameborder="0"
        //         style={{
        //           width: '100%',
        //           height: '100%'
        //         }}
        //         src={src}
        //       />
        //     } else {
        //       return <embed title={c.file.name} name={c.file.name} src={url} width={"100%"} height={"100%"} style={{ position: 'absolute' }} type={"application/pdf"} />
        //     }
        //   },
        // })
      }
      else {

        if (!BsyUtils.isObjectEmpty(config.bindWidget)) {
          if (config.openDown) {
            if (BsyUtils.isDingdingBrowser()) {
              window.FX.Utils.dataAjax({
                url: "/sso/getJumpUrl",
                data: {
                  url: url
                }
              }, function (data) {
                BsyUtils.redirectTo(data.url, "_blank");
                setpdf(c);
              }, null);
              return;
            }

            // let title = "";
            // if (c.file.name.indexOf("docx") > -1) {
            //   title = React.language("data.word");
            // } else {
            //   title = React.language("data.pdf");
            // }

            // BsySlidePane({
            //   title: title,
            //   hasHeader: true,
            //   onContentCreate: (ref) => {
            //     if (c.file.name.indexOf("docx") > -1) {

            //       var obj = c.file;
            //       var rets = "url=" + encodeURIComponent(downloadUrl);
            //       rets += "&mime=" + encodeURIComponent(obj.mime);
            //       rets += "&name=" + encodeURIComponent(obj.name);
            //       rets += "&key=" + encodeURIComponent(obj.qnKey);
            //       rets += "&size=" + encodeURIComponent(obj.size);

            //       var src = "https://" + (window._bby_config.office_domain || 'office.baibaoyun.com') + "/op/view.aspx?" + rets;

            //       return <iframe title={c.file.name} name={c.file.name}
            //         className="file-box-preview"
            //         frameborder="0"
            //         style={{
            //           width: '100%',
            //           height: '100%'
            //         }}
            //         src={src}
            //       />
            //     } else {
            //       return <embed title={c.file.name} name={c.file.name} src={url} width={"100%"} height={"100%"} style={{ position: 'absolute' }} type={"application/pdf"} />
            //     }
            //   },
            // })
            popup(c, url, downloadUrl)
          }

          setpdf(c);

        }
        else {
          if (BsyUtils.isDingdingBrowser()) {
            window.FX.Utils.dataAjax({
              url: "/sso/getJumpUrl",
              data: {
                url: url
              }
            }, function (data) {
              BsyUtils.redirectTo(data.url, "_blank");
            }, null);
            return;
          }
          popup(c, url, downloadUrl)
          // BsySlidePane({
          //   title: React.language("data.pdf"),
          //   hasHeader: true,
          //   onContentCreate: (ref) => {
          //     return <embed src={url} width={"100%"} height={"100%"} style={{ position: 'absolute' }} type={"application/pdf"} />
          //   },
          // })
        }

      }
    }

    function popup(c, url, downloadUrl) {
      let title = "";
      if (c.file.name.indexOf("docx") > -1) {
        title = React.language("data.word");
      } else {
        title = React.language("data.pdf");
      }


      BsySlidePane({
        title: title,

        onContentCreate: () => {
          if (c.file.name.indexOf("docx") > -1) {

            var obj = c.file;
            var rets = "url=" + encodeURIComponent(downloadUrl);
            rets += "&mime=" + encodeURIComponent(obj.mime);
            rets += "&name=" + encodeURIComponent(obj.name);
            rets += "&key=" + encodeURIComponent(obj.qnKey);
            rets += "&size=" + encodeURIComponent(obj.size);

            var src = "https://" + (window._bby_config.office_domain || 'office.baibaoyun.com') + "/op/view.aspx?" + rets;

            return <iframe title={c.file.name} name={c.file.name}
              className="file-box-preview"
              frameborder="0"
              style={{
                width: '100%',
                height: '100%'
              }}
              src={src}
            />
          } else {

            return <iframe
              src={url}
              title={title}
              style={{
                display: "block",
                width: "100%",
                height: "100%",
              }}
              frameborder={"0"}
            />
          }
        },
      })
    }

  }

  onMessage = (event) => {
    // console.log(event);

    if (event.data && "token" in event.data) {
      if (event.data.token === "printed-close") {
        this.showPane.closeAlter();
      }
    }
  };

  _getLinkValueMap = (t, e) => {
    let a = {};
    BsyUtils.forEach(e, function (t, e) {
      let i = _.get(e, "widget.widgetName");
      i && (a[i] = _.get(e, "widget.type"))
    });
    let n = {};
    BsyUtils.forEach(t, function (t, e) {
      switch (a[t]) {
        case "user":
        case "dept":
          n[t] = _.get(e, "_id", null) || _.get(e, "id", null) || e;
          break;
        case "usergroup":
        case "deptgroup":
          n[t] = _.map(e, function (t) {
            return t._id || t.id || t
          });
          break;
        case "datetime":
          let i = BsyUtils.parseDate(e);
          n[t] = i ? i.getTime() : null;
          break;
        default:
          n[t] = e
      }
    });
    return n
  }

  getViewVisibleMap = () => {
    let b = this;

    if (!this.showRulesProcessor) {

      this.tabMap = {};
      this.showRules = {};
      this.subVisbleMaps = {}
      this.subColumnVisibleMaps = {}

      this.multiTabs = this.form.options.multiTabs;
      var items = this.form.options.items;
      var tabsItem = [];//临时构建标签页到items中
      BsyUtils.forEach(this.multiTabs, function (tabindex, tabdata) {
        tabsItem.push(
          {
            label: React.language('multi.tab.name') + '.' + tabdata.title,
            widget: {
              widgetName: tabdata.name,
              type: 'tabs'
            }
          }
        )
      })
      this.showRulesProcessor = new ShowRulesProcessor({
        fieldShowRules: this.fieldShowRules,
        fields: [...items, ...tabsItem],
      });
    }


    let value = this.form.getCacheValue();

    this.showRules = {};
    this.subVisbleMaps = {}
    this.subColumnVisibleMaps = {}


    this.showRules = this.showRulesProcessor.getViewVisibleMap(value, function (t) {

      let visible = false

      if (!BsyUtils.isObjectEmpty(b.optAuth))
        visible = b.optAuth[t]
      // console.log(`${t} ${visible}`);
      return visible
    });
    BsyUtils.forEach(this.showRules, (key, val) => {
      if (key.indexOf('tab_') > -1) {
        if (!val) {
          BsyUtils.forEach(b.tabMap[key], (tabkey, tabval) => {
            this.showRules[tabval] = false;
          })
        }
      }
    })

    BsyUtils.forEach(this.itmes, function (t, i) {
      let a, n, e, s, o;

      if (i.widget && "subform" === i.widget.type) {
        a = i.widget.widgetName;
        e = _.get(b.subformFieldShowRules, a);

        if (!BsyUtils.isObjectEmpty(e)) {
          n = new ShowRulesProcessor({
            fieldShowRules: e,
            fields: i.widget.items
          });//(e, i.widget.items);
          e = value[a];
          s = {};
          BsyUtils.forEach(e, function (t, e) {
            e = b._getLinkValueMap(e, i.widget.items);
            s[t] = n.getViewVisibleMap(e, function () {
              return false
            })
          });
          b.subVisbleMaps[a] = s;
          o = {};
          BsyUtils.forEach(s, function (t, e) {
            BsyUtils.forEach(e, function (t, e) {
              BsyUtils.isNull(o[t]) ? o[t] = !1 === e : o[t] = o[t] && !1 === e
            })
          })
          b.subColumnVisibleMaps[a] = o
        }

      }
    })

    // console.log('formData getViewVisibleMap showRules', this.showRules)
    // console.log('formData getViewVisibleMap subVisbleMaps', this.subVisbleMaps)
    // console.log('formData getViewVisibleMap subColumnVisibleMaps', this.subColumnVisibleMaps)

  }

  doVerify = () => {
    let a = this
      , c = {
        result: !0
      };

    if (a.ignoreAuth) {
      return c;
    }

    this.getViewVisibleMap();

    let d = this.form.options.resultWidgets;
    for (let e in d) {
      let f = d[e];

      if (f) {
        let isVisible = f.isVisible();
        //字段可见，然后所在的标签页是否可见，不可见则忽略
        let tab = f.getTabName()

        if (isVisible) {
          if (a.showRules && a.showRules.hasOwnProperty(e)) {
            isVisible = a.showRules[e];
          }
          if (tab) {
            if (a.showRules && a.showRules.hasOwnProperty(tab)) {
              if (a.showRules[tab] === false) {
                isVisible = false;
              }
            }
          }
          if (isVisible && this.dataTable) {
            isVisible = this.dataTable.getWidgetVisible(e)
          }
        }

        if (isVisible) {

          if (f.getWidgetType() === 'subform') {
            f.setViewVisibleMap(this.subVisbleMaps[f.getWidgetName()]);
          }

          if (!f.checkValidate()) {
            c.result = !1

            if (f.getWidgetType() === 'subform') {

              let errorWidgets = f.getErrorWidgets();


              if (!this.dataTable) {
                this.onWidgetError({
                  name: f.getWidgetName(),
                  type: f.getWidgetType(),
                  errs: errorWidgets,
                  errMsg: f.getInvalidateTypeText() || React.language('item.required'),
                })
              } else {
                BsyUtils.forEach(errorWidgets, (index, widget) => {
                  if (this.dataTable) {
                    let widgetElement1 = this.form.getCurrentFieldElement(widget.name, widget.idx);
                    if (widgetElement1) {
                      this.dataTable.renderErrorTip(widgetElement1, widget.errMsg);
                    }
                  }
                })
              }
              if (errorWidgets.length) {
                c.errMsg = c.errMsg || React.language('validate.tip', { name: a.labelMap[errorWidgets[0].name] })
              }


            } else {

              if (this.dataTable) {
                let widgetElement = this.form.getCurrentFieldElement(f.getWidgetName(), -1, f);
                if (widgetElement) {
                  this.dataTable.renderErrorTip(widgetElement, f.getInvalidateTypeText());
                }
              } else {
                if (this.onWidgetError) {

                  this.onWidgetError({
                    name: f.getWidgetName(),
                    type: f.getWidgetType(),
                    errMsg: f.getInvalidateTypeText() || React.language('item.required'),
                  })
                }
              }

              c.errMsg = c.errMsg || React.language('validate.tip', { name: a.labelMap[f.getWidgetName()] })
            }
          }
        }
      }
    }
    if (c.result) {

      // if (!BsyUtils.isObjectEmpty(this.validators)) {
      //   this.rowRely._structureWidgets(this.formItems, this.getObjectValue())
      // }
      BsyUtils.forEach(this.validators, function (b, d) {
        let e = a._calFormula(d.formula);
        if (!e) {
          c.result = !1
          c.errMsg = c.errMsg || d.remind
          return !1
        }

      });
    }
    return c;
  }

  triggerEvent = (b, cb, mode) => {
    let c = this.form.options;
    let d = this
    let e = b;

    if (!b) {
      cb && cb();
      return;
    }
    if (b.controlType === "module") {
      cb && cb();
      return
    };


    //图片为空的时候 ，不触发功能插件
    if (b.type === "image") {
      let widgets = d.form.getWidgetByName(e.path, e.rowIdx);
      if (!widgets) {
        cb && cb();
        return;
      }
      if (BsyUtils.isObjectEmpty(widgets.getValue())) {
        cb && cb();
        return;
      }
    }

    if (this.ajaxLoading) {
      if (this.form.showMessage) {
        this.form.showMessage({
          msgbase: React.language('data.submit.c.ing'),
        }, () => {
          // cb && cb();
          // 这里需要重新触发事件，因为事件触发后，会重置ajaxLoading为false，导致无法触发事件
          // d.ajaxLoading = false;
          // 检测到公式联动执行完成后，自动恢复扩展触发的逻辑
          d.triggerEvent(b, cb, mode)
        });
      }
      return false;
    }

    let g = {
      widgetAlias: e.widgetNameAlias ? e.widgetNameAlias : e.name,
      widgetName: e.name,
      appId: c.refAppId || c.appId, // 后端一直只读appid 
      formId: c.formId || c.entryId,
      entryId: c.formId || c.entryId,
      dataId: c.dataId,
    };
    // mode = mode || "event"
    let extendSet = null;
    g.mode = "event";
    if (b.type === 'dataload') {
      extendSet = b.loaddataconfig ? b.loaddataconfig.extendSet : null;
      if (!extendSet) {
        cb && cb()
        return
      }
      g.mode = extendSet.funMode;
    } else {

      if (b.type === 'subform') {
        if (mode === 'dataload') {
          extendSet = b.loaddataconfig ? b.loaddataconfig.extendSet : null;
          if (!extendSet) {
            cb && cb()
            return
          }
          g.mode = extendSet.funMode;
        } else {
          if (b.hasOwnProperty("extendSet") && b.extendSet) {
            extendSet = b.extendSet;
            g.mode = extendSet.funMode;
          } else {
            g.mode = b.funMode;
          }
        }
      } else {
        if (b.hasOwnProperty("extendSet") && b.extendSet) {
          extendSet = b.extendSet;
          g.mode = extendSet.funMode;
        } else {
          g.mode = b.funMode;
        }
      }
    }

    if (g.mode === "all") {
      let validatormode = true
      let module = [];
      let libs = [];
      let events = [];
      let backEvents = false;
      let datahelpids = null;
      let status = false;

      if (extendSet) {
        datahelpids = extendSet.datahelpids || []
        module = extendSet.module || []
        libs = extendSet.libs || []
        backEvents = extendSet.backEvents || false
        status = extendSet.hasOwnProperty('status') ? extendSet.status : true;// || false
        events = extendSet.events || [];
      }


      BsyUtils.forEach(module, function (a1, b1) {
        if (BsyUtils.isObjectEmpty(b1)) {
          validatormode = false;
          return !1;
        }
      })

      if (status === true && (datahelpids.length > 0 || events.length > 0 || libs.length > 0 || backEvents === true)) {

      } else {
        cb && cb();
        return;
      }


      if (libs && libs.length > 0 && module && (module || (BsyUtils.isArray(module) && validatormode))) {
        g.libs = libs;
        g.module = module;
      }
      if (extendSet) {
        if (extendSet && !BsyUtils.isObjectEmpty(extendSet.datahelpids)) {
          g.datahelpids = extendSet.datahelpids;
        }

        if (extendSet && !BsyUtils.isObjectEmpty(extendSet.events)) {
          g.events = extendSet.events;
        }
        g.status = extendSet.status;
        g.sort = extendSet.sort;
        g.backEvents = extendSet.backEvents;
      }
    }


    //插件
    if (g.mode === "module") {
      let validatormode = true
      let module = null;
      let libs = null;
      if (extendSet) {
        module = extendSet.module;
        libs = extendSet.libs;
      }
      else {
        module = b.module;
        libs = b.libs;
      }


      BsyUtils.forEach(module, function (a1, b1) {
        if (BsyUtils.isObjectEmpty(b1)) {
          validatormode = false;
          return !1;
        }
      })

      if (libs && libs.length > 0 && module && (module || (BsyUtils.isArray(module) && validatormode))) {
        g.libs = libs;
        g.module = module;
      }
      else {
        //功能插件 设置参数，不触发后端事件
        cb && cb();
        return;
      }
    }
    else if (g.mode === "datahelp") {
      if (extendSet && !BsyUtils.isObjectEmpty(extendSet.datahelpids)) {
        g.datahelpids = extendSet.datahelpids;
      }
      else {
        //功能插件 设置参数，不触发后端事件
        cb && cb();
        return;
      }
    }
    else if (g.mode === "formEvent") {
      if (extendSet && !BsyUtils.isObjectEmpty(extendSet.events)) {
        g.events = extendSet.events;
      }
      else {
        //功能插件 设置参数，不触发后端事件
        cb && cb();
        return;
      }
    }

    let items = {};
    if (c.hasOwnProperty('items') && !BsyUtils.isEmpty(c.items)) {
      BsyUtils.forEach(c.items, function (inx, val) {
        let t = val['widget']['type'];
        let wName = val['widget']['widgetName'];
        switch (t) {
          case "radiogroup":
          case "combo":
          case "checkboxgroup":
          case "combocheck":
            let w = d.form ? d.form.getWidgetByName(wName) : null;
            if (w) {
              items[wName] = w.getItemsValues()
            }
            break;
          case 'subform':
            let subw = d.form ? d.form.getWidgetByName(wName) : null;
            if (subw) {
              let subwop = subw.options;
              items[wName] = [];
              let subitems = new Array(subw.dataSource.length)
              subitems.fill({});
              subwop.items && BsyUtils.forEach(subwop.items, function (subk, subv) {
                let wvaltype = subv.widget.type
                switch (wvaltype) {
                  case "radiogroup":
                  case "combo":
                  case "checkboxgroup":
                  case "combocheck":
                  case 'subform_radiogroup':
                  case 'subform_combo':
                  case 'subform_checkboxgroup': {
                    var n = subw.dataSource.length;
                    for (let index = 0; index < n; index++) {
                      const element = subw.subformComponents[index][subv.widget.widgetName];
                      subitems[index][subv.widget.widgetName] = element.getItemsValues()
                    }
                    break;
                  }
                  default: {

                  }
                }


                //   let subWidgetName = subv.widget.widgetName;
                //   let subWidgetData = d.form ? d.form.getWidgetByName(wName + '.' + subWidgetName) : d.getWidgetByName(wName + '.' + subWidgetName);
                //   subWidgetData && BsyUtils.forEach(subWidgetData, function (wkey, wval) {
                //     let wvalopt = wval['options'];
                //     let oriWidget = wval['oriWidget'];
                //     let wvaltype = wvalopt.type;
                //     switch (wvaltype) {
                //       case "radiogroup":
                //       case "combo":
                //       case "checkboxgroup":
                //       case "combocheck":
                //       case 'subform_radiogroup':
                //       case 'subform_combo':
                //       case 'subform_checkboxgroup':
                //       case 'subform_combocheck':
                //         if (oriWidget && oriWidget.hasOwnProperty('valueMap') && !BsyUtils.isObjectEmpty(oriWidget.valueMap)) {
                //           BsyUtils.forEach(oriWidget.valueMap, function (itinx, itval) {
                //             items[wName] = items[wName] || [];
                //             items[wName][wkey] = items[wName][wkey] || {};
                //             items[wName][wkey][subWidgetName] = items[wName][wkey][subWidgetName] || [];
                //             items[wName][wkey][subWidgetName].push({ 'value': itval });
                //           })
                //         } else {
                //           if (wvalopt.items && !BsyUtils.isEmpty(wvalopt.items)) {
                //             BsyUtils.forEach(wvalopt.items, function (itinx, itval) {
                //               items[wName] = items[wName] || [];
                //               items[wName][wkey] = items[wName][wkey] || {};
                //               items[wName][wkey][subWidgetName] = items[wName][wkey][subWidgetName] || [];
                //               items[wName][wkey][subWidgetName][itinx] = { 'value': itval['value'] };
                //             })
                //           }
                //         }
                //         break;
                //       default:
                //     }
                //   })
              });
              items[wName] = subitems
            }

            break;
          default:
        }
      })
    }
    g = {
      ...g,
      ...{
        itemdata: items
      }
    }

    if (e.hasOwnProperty('subform') && e.subform) {
      let subform = d.form.getWidgetByName(e.subform.widgetName),
        subopt = subform.options;
      g = {
        ...g,
        ...{
          subformNameAlias: subopt.widgetNameAlias ? subopt.widgetNameAlias : subopt.widgetName,
          subformName: subopt.widgetName
        }
      }

      // let index = subform.$content.find('.subform-row').index(b.element.closest('.subform-row'));
      let index = b.rowIdx;//b.element.closest('.subform-row').attr('row-idx');
      if (index > -1) {
        g = {
          ...g,
          ...{
            index: index
          }
        }

      }
    }


    if ((e.triggerEvent || g.mode === "event" || g.mode === "module" || g.mode === "datahelp" || g.mode === "formEvent" || g.mode === "all") && !d.ajaxLoading) {
      if (this.mode === 'preview') {
        tipAlert({
          type: "warning",
          msg: React.language("preview.triggerEvent")
        })
        cb && cb();
        return
      }
      if (!['import', 'dataload', 'import-subform-field'].includes(mode)) {
        if (g.mode === "module") {
          let loading = false;
          BsyUtils.forEach(g.libs, function (a1, b1) {
            if (b1.loading === 'open') {
              loading = true;
              return !1;
            }
          })
          if (loading) {
            d.form.formLoadLayer()
          }
        } else if (g.mode === "datahelp") {
          d.form.formLoadLayer()
        }
        else if (g.mode === "all") {
          d.form.formLoadLayer()
        }
        else {
          d.form.formLoadLayer()
        }
      }


      g.data = d.eventGetValue();

      let relys = []; //记录会影响到的字段
      //重置所有错误信息
      if (this.form) {
        // this.form._clearerrcontrol();
        this.form.ajaxLoading = !0;
      }
      this.ajaxLoading = true;

      this.ajaxLoadingMsg = ""; //this.labelMap
      if (g.subformName) {
        // `「${str}」`

        this.ajaxLoadingMsg = `「${[g.subformName, g.widgetName].join('.')}」第${g.index}行扩展`; //this.labelMap
      } else {
        this.ajaxLoadingMsg = `「${this.labelMap[g.widgetName]}」扩展`; //this.labelMap
      }

      window.FX.Utils.dataAjax({
        url: "/data/eventtrigger",
        data: g
      }, function (h) {
        d.form.formLoadLayerRemove()

        relys = d._setEventResult(h, g);
        console.log('relys', relys)
        if (h.hasOwnProperty('out_msg') && h.out_msg) {
          tipAlert({
            type: "success",
            msg: h.out_msg
          })
        }
        if (h.hasOwnProperty('code') && h.code == 3333 && h.msg) {
          tipAlert({
            type: "warning",
            msg: h.msg
          })
        }
      }, function (a) {
        d.form.formLoadLayerRemove()
        let h = window.FX ? JSON.parse(a.responseText) : a.responseJSON || {},
          e = h.msg || React.language("mobile.msg.tip7");
        tipAlert({
          type: "warning",
          msg: e
        });
        relys = d._setEventResult(h, g);
      }, function () {
        d.ajaxLoading = false;
        d.ajaxLoadingMsg = '';
        d.form.formLoadLayerRemove();
        if (d.form)
          d.form.ajaxLoading = !1;
        cb && cb(relys);
      })
    } else {
      cb && cb();
    }
  }


  _setEventResult = (h, g) => {
    console.log({
      ...h
    })
    let relysobj = this._getEventRelys(h);
    const relys = this.relysMerge(relysobj, h, g);
    return relys;
  }

  _setWidgetDiy = (data) => {
    let _this = this;

    this._rederSubRely(data.subRely)

    if (data.result) {
      BsyUtils.forEach(data.result, (a1, b1) => {

        if (a1 === "tabs") {
          if (_this.form)
            _this.form._setTabs(b1);
          return;
        }

        if (_this.fieldMap[a1]) {
          let val = _this.fieldMap[a1].getValue();
          let widgetConfig = {};
          if (b1.hasOwnProperty('label')) {
            widgetConfig.label = b1.label;
          }
          if (b1.hasOwnProperty('description')) {
            widgetConfig.description = b1.description;
          }
          if (_this.form && _this.form.setLableConfig)
            _this.form.setLableConfig(a1, widgetConfig);

          let options = _this.getOptions(b1, _this.fieldMap[a1].type);

          if (_this.fieldMap[a1].type === 'subform') {
            if (options.items) {
              delete options.items;
            }
            if (options.data) {
              delete options.data;
            }
            _this.fieldMap[a1].setOptions(options);
            let data = [...b1.data]
            if (data.length > SUBFORM_MAX_LIMIT) {
              tipAlert({
                type: "warning",
                msg: React.language('subform.maxCountTip', { limit: SUBFORM_MAX_LIMIT })
              });
              return
            }

            //根据后端返回数据，合并data
            if (b1.items) {

              _this.fieldMap[a1].field.setWidgetItmesAll(b1.items);

              BsyUtils.forEach(b1.items, (rowkey, row) => {
                BsyUtils.forEach(_this.fieldMap[a1].items, (colkey, col) => {
                  if (row[col.widget.widgetName]) {
                    switch (col.widget.type) {
                      case "combo":
                      case "radiogroup": {

                        if (!BsyUtils.isObjectEmpty(row[col.widget.widgetName])) {

                          let val1 = null;
                          BsyUtils.forEach(row[col.widget.widgetName], (valkey, val) => {
                            if (val.selected) {
                              val1 = val.value;
                              return false;
                            }
                          })
                          if (val1) {
                            if (!data[rowkey][col.widget.widgetName])
                              data[rowkey][col.widget.widgetName] = val1;
                          }
                        }

                        break;
                      }
                      case "checkboxgroup":
                      case "combocheck": {
                        if (!BsyUtils.isObjectEmpty(row[col.widget.widgetName])) {

                          let val2 = [];
                          BsyUtils.forEach(row[col.widget.widgetName], (valkey, val) => {
                            if (val.selected) {
                              val2.push(val.value);
                            }
                          })
                          if (!BsyUtils.isObjectEmpty(val2)) {
                            if (!data[rowkey][col.widget.widgetName])
                              data[rowkey][col.widget.widgetName] = val2;
                          }
                        }

                        break;
                      }
                      default: {

                      }
                    }
                  } else {
                    switch (col.widget.type) {
                      case "combo":
                      case "radiogroup": {
                        // data[rowkey][col.widget.widgetName] = null;
                        break;
                      }
                      case "checkboxgroup":
                      case "combocheck": {
                        // data[rowkey][col.widget.widgetName] = [];
                        break;
                      }
                      default:
                    }
                  }
                })
              })
            }
            if (_this.form && _this.form.setSubConfig)
              _this.form.setSubConfig(a1, {
                itemsenable: b1.hasOwnProperty('itemsenable') ? b1.itemsenable : undefined,
                itemslabel: b1.hasOwnProperty('itemslabel') ? b1.itemslabel : undefined,
                itemsvisible: b1.hasOwnProperty('itemsvisible') ? b1.itemsvisible : undefined,
              })
            let ret = _this._subformValueMerge(val, data);

            if (b1.hasOwnProperty('selected')) {
              BsyUtils.forEach(b1.selected, (a1, b2) => {
                BsyUtils.forEach(b2, (colkey, col) => {
                  if (col === false) {
                    ret[a1][colkey] = null;
                  }
                })
              })
            }
            _this.fieldMap[a1].setValue(ret);
            // if (b1.items) {
            //   BsyUtils.forEach(b1.items, (rowkey, row) => {
            //     BsyUtils.forEach(_this.fieldMap[a1].items, (colkey, col) => {
            //       if (row[col.widget.widgetName]) {
            //         switch (col.widget.type) {
            //           case "combo":
            //           case "radiogroup": {

            //             if (!BsyUtils.isObjectEmpty(row[col.widget.widgetName])) {

            //               if (_this.fieldMap[a1].field.subformComponents[rowkey] &&
            //                 _this.fieldMap[a1].field.subformComponents[rowkey][col.widget.widgetName]) {

            //                 _this.fieldMap[a1].field.subformComponents[rowkey][col.widget.widgetName].options['items'] = row[col.widget.widgetName];
            //                 _this.fieldMap[a1].field.subformComponents[rowkey][col.widget.widgetName].rebuild();
            //               }


            //             }

            //             break;
            //           }
            //           case "checkboxgroup":
            //           case "combocheck": {
            //             if (!BsyUtils.isObjectEmpty(row[col.widget.widgetName])) {

            //               if (_this.fieldMap[a1].field.subformComponents[rowkey] &&
            //                 _this.fieldMap[a1].field.subformComponents[rowkey][col.widget.widgetName]) {

            //                 _this.fieldMap[a1].field.subformComponents[rowkey][col.widget.widgetName].options['items'] = row[col.widget.widgetName];
            //                 _this.fieldMap[a1].field.subformComponents[rowkey][col.widget.widgetName].rebuild();
            //               }

            //             }

            //             break;
            //           }
            //           default: {

            //           }
            //         }
            //       }
            //     })
            //   })
            // }

          } else {
            _this.fieldMap[a1].setOptions(options);
            if (b1.hasOwnProperty('selected') && b1.selected === false) {
              _this.fieldMap[a1].setValue(null);
              return;
            }

            switch (_this.fieldMap[a1].type) {
              case "combo":
              case "radiogroup": {
                if (b1.hasOwnProperty("data")) {
                  _this.fieldMap[a1].setValue(Array.isArray(b1.data) ? b1.data.join(',') : b1.data);
                }
                if (b1.hasOwnProperty("items")) {
                  if (BsyUtils.isObjectEmpty(b1.items)) {
                    _this.fieldMap[a1].setValue(null);
                  } else {
                    if (!b1.data) {
                      let data = null;
                      for (let i = 0; i < b1.items.length; i++) {
                        if (b1.items[i].selected) {
                          data = b1.items[i].value;
                        }
                      }
                      if (data) {
                        _this.fieldMap[a1].setValue(data);
                      }
                    }
                  }
                }

                break;
              }
              case 'text':
              case 'textarea': {
                if (b1.hasOwnProperty('data')) {
                  _this.fieldMap[a1].setValue(Array.isArray(b1.data) ? b1.data.join(',') : b1.data);
                }
                break;
              }
              case "checkboxgroup":
              case "combocheck": {
                if (b1.hasOwnProperty('data')) {
                  _this.fieldMap[a1].setValue(b1.data);
                }
                if (b1.hasOwnProperty("items")) {

                  if (BsyUtils.isObjectEmpty(b1.items)) {
                    _this.fieldMap[a1].setValue([]);
                  } else {
                    if (!b1.data) {
                      let data = [];
                      for (let i = 0; i < b1.items.length; i++) {
                        if (b1.items[i].selected) {
                          data.push(b1.items[i].value);
                        }
                      }
                      if (data) {
                        _this.fieldMap[a1].setValue(data);
                      }
                    }
                  }
                }
                break;
              }
              default: {
                if (b1.hasOwnProperty('data'))
                  _this.fieldMap[a1].setValue(b1.data);

                break;
              }
            }
          }
        }
      })
    }
  }

  getLimit = (limit, type) => {

    const object = {
      users: [],
      sortValue: [],
    };
    BsyUtils.forEach(limit, (key, val) => {
      object[key] = val;

      if (key === "creator") {
        object.sortValue.push("100000000000000000000001"); // 当前用户
      } else {
        if (Array.isArray(val)) {
          object.sortValue = [...object.sortValue, ...val];
        }
      }
    })
    return object;

  }

  getOptions = (option, type) => {
    let opt = {};

    // data// : // "text"
    // description// : // "单行文本-描述"
    // enable// : // false
    // label// : // "单行文本-标题"
    // visible// : // true

    if (option.hasOwnProperty('enable')) {
      opt.eventEnable = option.enable;
    }
    if (option.hasOwnProperty('visible')) {
      opt.eventVisible = option.visible;
    }
    if (option.hasOwnProperty('limit')) {
      opt.limit = this.getLimit(option.limit, type);
    }
    if (option.hasOwnProperty('data')) {
      switch (type) {
        case 'combo':
        case 'radiogroup':
        case 'text':
        case 'textarea': {
          opt.value = Array.isArray(option.data) ? option.data.join(',') : option.data;
          break;
        }
        default: {
          opt.value = option.data;
        }
      }
    }
    if (option.hasOwnProperty('items')) {
      opt.items = option.items;
    }
    if (option.hasOwnProperty('subform_create')) {
      opt.subform_create = option.subform_create;
    }
    if (option.hasOwnProperty('subform_insert')) {
      opt.subform_insert = option.subform_insert;
    }

    if (option.hasOwnProperty('subform_delete')) {
      opt.subform_delete = option.subform_delete;
    }
    if (option.hasOwnProperty('subform_edit')) {
      opt.subform_edit = option.subform_edit;
    }
    return opt;

  }

  //对比 扩展修改子表单前后的 数据id的变化，用于触发新增子表单数据的公式以及联动
  subformDataDiff = (submapbefore, submapafter) => {
    let relys = [];
    BsyUtils.forEach(submapafter, function (name, ids) {
      var ss = _.difference(ids, submapbefore[name])
      if (ss.length) {
        for (let i = 0; i < ss.length; i++) {
          let id = ss[i]
          relys.push([name, 'add', id].join('-'));
        }
      }
    })
    return relys;
  }

  setEventError = (other) => {
    let that = this;
    let _errcontrol = other?._errcontrol
    if (that.onWidgetError) {
      if (BsyUtils.isObjectEmpty(_errcontrol)) {
        that.onWidgetError(null, true)
      } else {

        if (that.onWidgetError) {

          let errmap = {};

          BsyUtils.forEach(_errcontrol, (widgetName, info) => {
            let widgets = that.getField(widgetName)
            if (info.name) {
              if (!errmap[info.name]) {
                errmap[info.name] = {
                  name: info.name,
                  type: 'subform',
                  errMsg: info.tip,
                  errs: [],
                };
              }
              BsyUtils.forEach(info.index, (i, v) => {
                errmap[info.name].errs.push({
                  name: widgetName,
                  idx: v,
                  errMsg: info.tip,
                })
              })
            } else {
              errmap[widgetName] = {
                name: widgetName,
                type: widgets.type,
                errMsg: info.tip,
              }
            }
          })

          if (BsyUtils.isObjectEmpty(errmap)) {
            that.onWidgetError(null, true)
          } else {
            BsyUtils.forEach(errmap, (widgetName, info) => {
              that.onWidgetError(info)
            })
          }
        }

      }
    }

  }

  //获取事件影响到的字段列表
  //并排除掉不相关的字段
  _getEventRelys = (data) => {
    let _this = this;
    let relys = [];
    let adds = [];
    this.triggerControl = null; //触发自己
    this.triggerWidget = null; //触发自己影响到的公式
    BsyUtils.forEach(data.result, function (a1, b1) {

      if (a1 == 'triggerControl') {
        _this.triggerControl = b1;
        return;
      }
      if (a1 == 'triggerWidget') {
        _this.triggerWidget = b1;
        return;
      }

      if (a1.indexOf('_widget_') > -1) {
        if (_this.fieldMap[a1] && _this.fieldMap[a1].type == 'subform') {
          if (b1.data.length) {
            adds.push(a1);
            for (let index = 0; index < b1.data.length; index++) {
              const element = b1.data[index];
              BsyUtils.forEach(element, (k1) => {

                let dt = [a1, k1].join('.');
                if (relys.indexOf(dt) == -1) {
                  relys.push(dt);
                }
              })

            }

          }
        } else {
          relys.push(a1);
        }
      }
    })

    let subRely = data.subRely;
    if (!BsyUtils.isObjectEmpty(subRely)) {

      BsyUtils.forEach(subRely, (a, c) => {
        if (c.hasOwnProperty("edit")) {
          BsyUtils.forEach(c.edit, function (editindex) {
            BsyUtils.forEach(c.edit[editindex], function (row) {
              BsyUtils.forEach(c.edit[editindex][row].data, function (cell) {
                let d = [editindex, cell].join('.') + '-edit-' + row; //这种执行子表单单行
                if (relys.indexOf(d) === -1) {
                  relys.push(d)
                }
              })
            })
          })
        }
        if (c.hasOwnProperty("delete")) {
          BsyUtils.forEach(c.delete, function (editindex) {
            let subform = _this.getField(editindex);
            if (subform) {
              let d = editindex;
              if (relys.indexOf(d) === -1) {
                relys.push(d)
              }
            }
          })
        }
        //记录会影响到子表单新增的字段，后面需要二次计算新增的字段行id
        if (c.hasOwnProperty("add")) {
          BsyUtils.forEach(c.add, function (editindex) {
            let d = editindex;
            if (adds.indexOf(d) === -1) {
              adds.push(d)
            }
          })
        }
      })
    }

    if (this.triggerControl) {
      delete data.result.triggerControl;
    }
    if (this.triggerWidget) {
      delete data.result.triggerWidget;
    }
    relys = BsyUtils.arrayUnique(relys)

    return {
      relys: relys,
      adds: adds,
    };
  }


  //处理子表单根据实际情况，产生的行数据编辑，删除 ，增加的逻辑
  _rederSubRely = (subRely) => {

    if (BsyUtils.isObjectEmpty(subRely)) {
      return;
    }
    let _this = this;

    var addObject = {} //优化新增逻辑
    BsyUtils.forEach(subRely, (a, c) => {
      if (c.hasOwnProperty("edit")) {
        BsyUtils.forEach(c.edit, function (editindex) {
          let subform = _this.getField(editindex);
          if (subform) {
            let sval = subform.getValue();
            BsyUtils.forEach(c.edit[editindex], function (row) {
              if (sval.length > row) {
                BsyUtils.forEach(c.edit[editindex][row].data, function (cell, data) {
                  let subformcell = _this.getFieldIndex([editindex, cell].join('.'), row)
                  if (subformcell) {
                    subformcell.setValue(data)
                  }
                })
              }
            })
            // subform.setValue(sval)
          }
        })
      }
      if (c.hasOwnProperty("delete")) {
        BsyUtils.forEach(c.delete, function (editindex) {
          let subform = _this.getField(editindex);
          if (subform) {
            let sval = subform.getValue();
            //删除子表单需要从大的数往小的数删除
            let tmpdeleteids = c.delete[editindex].sort(function (a, b) {
              return b - a;
            });
            BsyUtils.forEach(tmpdeleteids, function (index, row) {
              if (sval.length > row) {
                sval.splice(row, 1);
              }
            })
            subform.setValue(sval)
          }
        })

      }
      if (c.hasOwnProperty("add")) {
        BsyUtils.forEach(c.add, function (editindex) {
          let subform = _this.getField(editindex);
          if (subform) {
            if (!addObject[editindex]) {
              let sval = subform.field.getValue();
              addObject[editindex] = sval;
            }

            BsyUtils.forEach(c.add[editindex], function (row, data) {
              if (data.data) {
                addObject[editindex].push(data.data)
              } else
                addObject[editindex].push(data)
              if (addObject[editindex].length > subform.maxItemCount) {
                // subform._checkItemLimit()
                return !1;
              }
            })
            // subform.setValue(sval)
          }
        })
      }
    })
    _.forEach(addObject, (val, key) => {
      let subform = _this.getField(key);
      subform.setValue(val)
    })
  }

  _subformValueMerge = (data, val) => {
    let tmp = [];
    BsyUtils.forEach(data, function (a1, b1) {
      let tmp1 = { ...b1 }
      let tmp2 = {};


      BsyUtils.forEach(tmp1, function (a2, b2) {
        if (b2) {
          if (b2.hasOwnProperty('data')) {
            tmp2[a2] = b2.data;
          }
          else {
            tmp2[a2] = b2;
          }
        }
      })

      // for (let k in tmp1) {
      //   if(tmp1[k]) {
      //     if (tmp1[k].hasOwnProperty('data')) {
      //       tmp2[k] = tmp1[k].data;
      //     }
      //     else {
      //       tmp2[k] = tmp1[k];
      //     }
      //   }
      // }
      tmp.push(tmp2);
    })
    let newData = [...val];
    if (val) {
      newData = [];
      BsyUtils.forEach(val, function (a1, b1) {
        let d = { ...tmp[a1], ...b1 };
        newData.push(d);
      })
    }
    return newData;
  }

  relysMerge = (relysobj, h, g) => {
    var relys = [];
    let d = this;
    relys = relysobj.relys;
    let submapbefore = {};
    BsyUtils.forEach(relysobj.adds, function (k, v) {
      submapbefore[v] = d.form._getSubformIds(v)
    })
    let submapafter = {};
    // fxm 给移动端使用的，不用调整
    if (window.FXM) {
      d.form._setWidgetDiy(h, d.form, g.index, g);
      if (h.other && h.other._errcontrol)
        this.form._seterrcontrol(h.other._errcontrol)
    }
    d._setWidgetDiy(h);

    this.setEventError(h.other)
    BsyUtils.forEach(relysobj.adds, function (k, v) {
      submapafter[v] = d.form._getSubformIds(v)
    })
    relys = relys.concat(d.subformDataDiff(submapbefore, submapafter));

    return relys
  }

  doSubmit = (success, error, extData) => {

    if (this.submitIng) {
      return;
    }

    let formOptions = this.form.options;

    console.log('doSubmit')
    let submitData = {
      dataId: formOptions.mode === 'edit' ? formOptions.dataId : undefined,
      ...this.submitData,
      values: this.getValue(),
      hasResult: !0,
      flowAction: formOptions.flowAction,
      flowType: formOptions.flowType,
      candidateId: formOptions.candidateId,
      designDataId: formOptions.mode === 'copy' ? undefined : formOptions.designDataId,
      islinkquery: formOptions.islinkquery,
      islinkdata: formOptions.islinkdata,
      widgetName: formOptions.designWidgetName,
      subformName: formOptions.designSubformName,
      appId: formOptions.appId,
      entryId: formOptions.entryId,
      formId: formOptions.formId || formOptions.entryId,
      // refAppId: this.refAppId,
      checkRepeat: this.checkRepeat,
      // hasResult: !0,
      authGroupId: formOptions.popupFormPath && formOptions.popupFormPath.length > 0 ? null : formOptions.authGroupId !== -99 ? formOptions.authGroupId : undefined, //this.authGroupId,
      popupFormPath: formOptions.mode === 'copy' ? formOptions.popupFormPath : formOptions.extDashData ? null : formOptions.popupFormPath,
      extDashData: formOptions.extDashData,
    };
    if (!BsyUtils.isObjectEmpty(extData)) {
      submitData = { ...submitData, ...extData }
    }

    this.submitIng = true;

    if (formOptions.flows?.hasDeptManagerChain || formOptions.needSpecifyCreatorDept) {
      if (window.localDevInfo.user.current_departments.length > 1) {
        BsyDialog({
          title: React.language('select.approval.dept'),
          height: 480,
          width: 500,
          noFooter: false,
          okText: React.language("ok"),
          cancelText: React.language("cancel"),
          onContentCreate: () => {
            let approvalDepts = [];
            window.localDevInfo.user.current_departments.map(res => {
              approvalDepts.push({
                text: res.name,
                value: res._id
              })
            })
            return <div className="select-approval-dept">
              <div className="approval-hint">
                {React.language("select.approval.dept.tip")}
              </div>
              <BsySelect
                waterMark={React.language("select.approval.dept.tip2")}
                allowBlank={false}
                searchable={false}
                items={approvalDepts}
                onStopEdit={(val) => {
                  submitData.creatorDept = val;
                }}
              ></BsySelect>
            </div>
          },
          onOk: () => {
            if (!submitData.creatorDept) {
              tipAlert({
                type: "warning",
                msg: React.language("select.approval.dept.tip1")
              })
              return !1
            }
            this.submitFetch(formOptions, submitData, success, error)
          },
          onCancel: () => {
            this.submitIng = false;
            error && error({});
          }
        })
      } else {
        submitData.creatorDept = window.localDevInfo.user.current_departments.length > 0 && window.localDevInfo.user.current_departments[0]._id;
        this.submitFetch(formOptions, submitData, success, error)
      }
    } else {
      this.submitFetch(formOptions, submitData, success, error)
    }
  }

  submitFetch = (formOptions, submitData, success, error) => {




    if (!BsyUtils.isObjectEmpty(submitData.extDashData) && submitData.extDashData?.formId?.includes("@")) {
      [submitData.formId, submitData.appId] = submitData.extDashData.formId.split("@");
    }
    if (
      !BsyUtils.isObjectEmpty(submitData.popupFormPath) &&
      submitData.popupFormPath[submitData.popupFormPath.length - 1]?.formId?.includes("@") &&
      !submitData.popupFormPath[submitData.popupFormPath.length - 1]?.menuType
    ) {
      [submitData.formId, submitData.appId] = submitData.popupFormPath[submitData.popupFormPath.length - 1].formId.split("@");
    }

    React.axios(formOptions.submitUrl, submitData).then(res => {
      this.submitIng = false
      BsyUtils.showAjaxTip(res.data, () => {
        success && success(res);
      }, () => {
        error && error(res);
      })
      console.log(res)

    }).catch(res => {
      this.submitIng = false
      console.log(res)
      error && error(res);
    })
  }

  setRowErrorTip = (a) => {
    let _this = this;
    if (!a.result) {
      //数据验证的时候，提示的错误信息
      _this.errMsg = a.errMsg ? a.errMsg : React.language("form.submit.invalid")
      if (_this.dataTable) {
        _this.dataTable.renderRowFieldErrorTip(_this.fieldData._id, _this.errMsg);
        _this.dataTable.renderRowLinkingTip(_this.fieldData._id, '');
      } else {
        tipAlert({
          type: "warning",
          msg: _this.errMsg
        });
      }

    }
    return a.result
  }

  // ["back", "save", "transfer", "close"] 只校验重复值的问题 
  doVerifySubformSubmit = () => {
    if (!this.checkRelyAsyncState()) {
      return false
    }
    let c = {
      result: !0
    };

    let d = this.form.options.resultWidgets;
    for (let e in d) {
      let f = d[e];

      if (f) {
        if (f.getWidgetType() === 'subform') {
          f.errorWidgets = [];
          f.checkDataRepeat()



          let errorWidgets = f.getErrorWidgets();
          if (errorWidgets && errorWidgets.length) {
            if (!this.dataTable) {
              this.onWidgetError({
                name: f.getWidgetName(),
                type: f.getWidgetType(),
                errs: errorWidgets,
                errMsg: f.getInvalidateTypeText() || React.language("repeat.tip"),
              })
            } else {
              BsyUtils.forEach(errorWidgets, (index, widget) => {
                if (this.dataTable) {
                  let widgetElement1 = this.form.getCurrentFieldElement(widget.name, widget.idx);
                  if (widgetElement1) {
                    this.dataTable.renderErrorTip(widgetElement1, widget.errMsg);
                  }
                }
              })
            }
            if (f.getInvalidateTypeText() === React.language("repeat.tip")) {
              c.result = !1;
              c.errMsg = React.language("repeat.tip")
            }
          }
        }
      }
    }
    if (!this.setRowErrorTip(c)) {
      return false
    }

    return true
  }

  doVerifyAndSubmit = () => {

    if (!this.checkRelyAsyncState()) {
      // tipAlert({
      //   type: "warning",
      //   msg: 'checkRelyAsyncState'//_this.rowRely.getErrorWidgets()
      // });
      return false
    }

    let a = this.doVerify();
    //联动完成后再校验数据
    if (!this.setRowErrorTip(a)) {
      return false
    }

    return true
  }

}

export class memoryWidget {

  constructor(props) {

    // console.log(BsyUtils._isSubformWidget)
    // console.log(BsyUtils.isObjectEmpty)
    _._isSubformWidget = _._isSubformWidget || BsyUtils._isSubformWidget;
    _.isObjectEmpty = _.isObjectEmpty || BsyUtils.isObjectEmpty;

    var widget = this.N(props.widget, {});;
    this.type = _.get(widget, 'type');

    this.uuid = BsyUtils.Ids24();

    this.name = _.get(widget, 'widgetName');
    this.tab = _.get(props, 'tab');
    this.label = _.get(props, 'label');
    this.labelHidden = _.get(props, 'labelHidden');
    this.lineWidth = _.get(props, 'lineWidth');
    this.description = _.get(props, 'description');
    this.hint = _.get(widget, 'hint');
    this.widget = _.extend(widget);


    this.format = _.get(widget, 'format');
    this.items = _.get(widget, 'items');
    this.async = _.get(widget, 'async', null);
    this.rely = this.compatibleFilter(_.get(widget, 'rely'));
    this.visible = _.get(widget, 'visible', true);
    this.enable = _.get(widget, 'enable', true);
    this.loaddataconfig = _.get(widget, 'loaddataconfig', true);
    this.allowBlank = _.get(widget, 'allowBlank', true);

    this.field = _.get(props, 'field');
    this.extendSet = _.get(widget, 'extendSet');
    this.funMode = _.get(widget, 'funMode');
    this.controlType = _.get(widget, 'controlType');
    this.mode = _.get(widget, 'mode');
    this.maxFileCount = _.get(widget, 'maxFileCount', 1);
    this.maxItemCount = _.get(widget, 'maxItemCount', SUBFORM_MAX_LIMIT);
    this.linkForm = _.get(widget, 'linkForm');
    this.refAppid = _.get(widget, 'refAppid');
    this.linkFilter = _.get(widget, 'linkFilter');
    this.value = _.get(props, 'value', null);

    this.widgetNameAlias = _.get(widget, 'widgetNameAlias');
    this.subform = _.get(props, 'subform', null);
    if (this.subform) {
      this.path = [this.subform.widgetName, this.name].join('.');
      this.rowId = _.get(props, 'rowId', null);
      this.rowIdx = _.get(props, 'rowIdx', -1);
    } else {
      this.path = this.name;
    }

    // console.log(`memoryWidget constructor uuid:${this.uuid} ${this.label} ${this.rowId} ${this.rowIdx} ${this.path} `);

    this.subform_insert = _.get(widget, 'subform_insert', true);
    this.allowEdit = this.subform_edit = _.get(widget, 'subform_edit', true);
    this.allowDelete = this.subform_delete = _.get(widget, 'subform_delete', true);
    this.allowCreate = this.subform_create = _.get(widget, 'subform_create', true);
    this.allowInsert = this.subform_insert = _.get(widget, 'subform_insert', true);
    this.regex = _.get(widget, 'regex');
    this.rule = {};

    switch (this.type) {
      case "user":
      case "usergroup": {
        _.merge(this.rule, {
          isExternalLink: _.has(window.FX.STATIC, 'QTOKEN')
        })
        this.limit = _.get(widget, 'limit');
        this.deptLevel = _.get(widget, 'deptLevel');
        this.deptLevelLimit = _.get(widget, 'deptLevelLimit');
        break
      }
      case "dept":
      case "deptgroup": {
        _.merge(this.rule, {
          isExternalLink: _.has(window.FX.STATIC, 'QTOKEN')
        })
        this.limit = _.get(widget, 'limit');
        this.deptLevel = _.get(widget, 'deptLevel');
        this.deptLevelLimit = _.get(widget, 'deptLevelLimit');
        break
      }
      case "subform": {

        this.itemMap = {};
        for (let i = 0; i < this.items.length; i++) {
          this.itemMap[this.items[i].widget.widgetName] = this.items[i]
        }
        break;
      }
      case "location": {
        _.merge(this.rule, {
          limits: _.get(widget, 'limits'),
          radius: _.get(widget, 'radius')
        })
        break
      }
      case "address": {
        _.merge(this.rule, {
          needDetail: _.get(widget, 'needDetail')
        })
        break
      }
      case "number": {
        let minNumber = _.get(widget, 'minNumber');
        let maxNumber = _.get(widget, 'maxNumber');
        _.merge(this.rule, {
          minNumber,
          maxNumber
        })
        break
      }

      default: {
        if (this.regex) this.rule.pattern = new RegExp(this.regex)
        break;
      }
    }
    this.setDefaultValue(this.value)

  }

  setLimit = function (limit) {
    if (this.field) {
      this.field.setLimit(limit);
    }
  }

  //转换旧公式的写法
  compatibleFilter = function (rely) {

    if (!rely)
      return rely;
    if (!rely.ref) {
      return rely
    }
    if (!rely.data) {
      return rely
    }

    let filter = {
      rel: rely.data.rel,
      cond: []
    };

    _.forEach(rely.type, (item, index) => {

      let subobj = {};

      if (_._isSubformWidget(rely.fixed[index] || '')) {
        var subs = rely.fixed[index].split('.');
        subobj = {
          subform: subs[0],
          subField: subs[1]
        }
      }

      let filterItem = {
        ...(item ? item : {}),
        field: item ? item.name : rely.ref.field[index],
        mode: rely.widgets[index] == "fixed" ? 'fixed' : 'depend',
        method: rely.method[index],
        depend: rely.widgets[index] == "fixed" ? null : {
          field: rely.widgets[index],
          ...subobj
        },
        value: rely.widgets[index] == "fixed" ? null : rely.fixed[index]
      }

      filter.cond.push(filterItem)



    })

    // , n = t.subform
    // , r = t.subField

    rely.filter = filter;
    // console.log('compatibleFilter', rely.filter)
    return rely;
  }

  fireLink = (subformMode) => {
    if (this.form) {
      this.form.fireWidgetRelyEvent(this, !1, subformMode);
    }
  }
  fireSubformRowLink = function (e, t) {
    this.form && (//this.form.setNeedCache(!0),
      this.form.fireSubformRowRely(this, e, t))
  }

  setOptions = (d) => {
    let that = this;
    _.forEach(d, (val, key) => {
      that[key] = val;
      if (that.field.options) {

        if ("eventEnable" === key) {
          that.field.options["enable"] = val;
        } else if ("eventVisible" === key) {
          that.field.options["visible"] = val;
        } else {
          that.field.options[key] = val;
        }
      }
    })
    if (that.form && that.form.formFieldsAttr) {
      that.form.updateFromFieldsAttr(this.path, d);
    }
    that.field.rebuild();

  }

  bindField = (field) => {
    this.field = field
  }

  setForm = (form) => {
    this.form = form;
  }

  setDefaultValue = function (e, t) {
    if (_.isNil(e)) {
      if (!_.isObjectEmpty(this.widget.value)) {
        this.parseDefaultValue(this.widget.value, t)
      } else {
        this.setValue(null)
      }
    } else {
      this.setValue(e)
    }

    // _.isNil(e) ? _.isObjectEmpty(this.widget.value) || this.parseDefaultValue(this.widget.value, t) : this.setValue(e)
  }

  N = function (e, t) {
    var n, a = t.API, u = _.merge({}, e), s = e.type, d = e.items;

    _.includes(["combo", "combocheck"], s) && u.async && (u.async = {
      url: e.async ? e.async.url : a.data,// (0, o.ac_)(a.data.link_values),
      data: _.merge(_.pick(u.async.data, ["field", "formId", "sortField", "sortMode", "sortType", "refAppId", 'filter']))
    })

    if (_.includes(["combo", "radiogroup"], s) && d) {
      _.forEach(d, (function (e) {
        if (e.selected) {
          n = e.isOther ? null : e.value;
          return !1
        }

      }
      ));
      n && _.merge(u, {
        value: n
      })
    }

    if (_.includes(["combocheck", "checkboxgroup"], s) && d) {
      var m = [];
      _.forEach(d, (function (e) {
        e.selected && m.push(e.value)
      }
      ))
      m.length && _.merge(u, {
        value: m
      })
    }


    // if (_.includes(["sale_stage"], s) && (0, o.dpJ)(d) > 0) {
    //   var p = _.pick((0, o.PsQ)(d), ["template_id", "stage_id"]);
    //   (0, o.xbD)(p) || _.merge(u, {
    //     value: k(I({}, p), {
    //       needRewrite: !0
    //     })
    //   })
    // }
    // _.includes(["account_pool", "leads_pool"], s) && (0, o.dpJ)(d) > 0 && (_.forEach(d, (function (e) {
    //   if (e.selected)
    //     return r = e.value,
    //       !1
    // }
    // )),
    //   r && _.merge(u, {
    //     value: r
    //   }));
    // if (_.includes(["linkobject"], s) && (0, o.dpJ)(f) > 1 && (0, o.xbD)(e.value)) {
    //   var v = (0, o.sEJ)(f, "selected");
    //   _.merge(u, {
    //     value: {
    //       link_form: _.get(v, "form", _.get(f, "0.form"))
    //     }
    //   })
    // }



    ["combo", "combocheck", "checkboxgroup", "radiogroup"].indexOf(s) > -1 && !d && !_.get(u, "async") && _.merge(u, {
      items: [{
        value: React.language("field.options", {
          num: 1
        }),
        text: React.language("field.options", {
          num: 1
        })
      }, {
        value: React.language("field.options", {
          num: 2
        }),
        text: React.language("field.options", {
          num: 2
        })
      }, {
        value: React.language("field.options", {
          num: 3
        }),
        text: React.language("field.options", {
          num: 3
        })
      }]
    })
    // _.includes(["linkquery"], s) && _.merge(u, {
    //   linkForm: (0, o.CM)(e.linkForm, i.formId)
    // })
    return u
  }

  cc = function (e, t) {
    switch (e) {
      case "user": {
        if (t) {

          if (t === BsyConfig().USER_ID.CurrentUser) {
            return window.FX.STATIC.user
          }

          let id = t.id || t._id || t;
          if (id === BsyConfig().USER_ID.CurrentUser) {
            return window.FX.STATIC.user
          }
          if (window.userSelectMap) {
            if (window.userSelectMap[id])
              return window.userSelectMap[id]
            if (!_.isString(t)) {
              window.userSelectMap[id] = t;
            }
          }
          return t;
        }
        return null;
      }
      case "usergroup": {
        let index = -1;
        if (t) {
          t.map((event, i) => {

            if (i === BsyConfig().USER_ID.CurrentUser) {
              index = i
            } else {
              let id = event.id || event._id || event;
              if (id == BsyConfig().USER_ID.CurrentUser) {
                index = i
              }
            }

          })
          if (index > -1) {
            t.splice(index, 1)
            t.push(window.FX.STATIC.user)
          }
          return t;
        }
        return null;

      }
      case "dept":
      case "deptgroup":
        return t;
      default: {
        return t;
      }
    }
  }

  parseDefaultValue = function (e, t) {
    var n = this;
    switch (this.type) {
      case "user":
      case "usergroup":
      case "dept":
      case "deptgroup":
        this.setValue(n.cc(this.type, e, t));
        break;
      case "datetime": {
        e = this.str2DateTime(e);
        this.setValue(e);
        break;
      }
      case 'subform':

        let subvalue = [];
        for (let i = 0; i < e.length; i++) {
          let element = e[i];
          var rowval = {};
          _.forEach(element, function (val, key) {
            if (n.itemMap[key]) {
              rowval[key] = n.cc(n.itemMap[key].widget.type, val)
            } else {
              rowval[key] = val;
            }

          })
          subvalue.push(rowval);
        }

        this.setValue(subvalue);
        break;
      default:
        this.setValue(e)
        break
    }
    this.valueSource = "default"
  }

  str2DateTime = (val) => {

    if (_.isNil(val)) {
      return null;
    }

    let c = null;
    val = (BsyUtils.isString(val) && val.indexOf("T") === -1) ? val.replace(/-/g, "/") : val;
    c = "today" === val ? new Date() : new Date(val);

    if (c) {
      c = dayjsUtils.timeToTZ(c);
      c = BsyUtils.getFormatDate(c, this.format);
      c = dayjsUtils.timeToLocal(c).date;
    }
    let d = c.getTime();
    if (isNaN(d)) {
      val = null;
    } else {
      val = d;
    }
    return val;
  }

  setItemValue = function (el) {
    if (this.linkValue[el.rowIdx]) {
      this.linkValue[el.rowIdx][el.name] = el.linkValue;
    }
  }

  setValue = function (val, cb, reWrite) {

    if (this.field && !reWrite) {

      switch (this.type) {
        case "text": {
          val = BsyUtils.toStringDetailed(val).trim();
          val = BsyUtils.getAddressText(val);
          break
        }
        case "textarea": {
          val = BsyUtils.toStringDetailed(val);
          val = BsyUtils.getAddressText(val);
          break
        }
        case "user":
        case "usergroup":
        case "dept":
        case "deptgroup": {
          val = this.cc(this.type, val, {});
          break;
        }
        case "datetime": {
          val = this.str2DateTime(val);
          break;
        }
        default:
          if (_.isNil(val)) {
            val = null;
          }
      }

      //此处不能添加回调，会导致，子表单数据提前更新，在数据管理中产生数据dom 与memwidget 数据不一致的情况
      this.field.setValue(val);

      // if (this.type == 'subform') {
      //   val = this.field.getObjectValue();
      // } else {
      //   if (this.form && this.form.onRelyDone)
      //     this.form.onRelyDone(this.field, this.rowIdx);
      //   // val = this.field.getValue();
      // }
    }


    // if (this.form) {
    //   let label = this.label;
    //   if (this.rowId) {
    //     label = [this.form.rowRely.fieldMap[this.subform.widgetName].label, this.label, this.rowId].join('.')
    //   }
    //   // console.log('rowExecuteRely_3_0 uuid:' + this.uuid + ' ' + label, val)
    // }


    if (this.form && this.form.setFieldValue) {
      this.form.setFieldValue(this.path, val, this.rowIdx, null, this.rowId);
    }

    switch (this.type) {
      case "text": {
        this.linkValue = this.value = BsyUtils.toStringDetailed(val).trim();
        break;
      }
      case "textarea": {
        this.linkValue = this.value = BsyUtils.toStringDetailed(val);
        break;
      }
      case 'subform': {
        if (this.field)
          this.value = this.linkValue = this.field.getObjectValue();
        else
          this.value = this.linkValue = val;
        break;
      }
      case "user":
      case "dept": {
        val = this.field.getValue()
        this.cacheValue = val;
        if (_.isString(val)) {
          this.value = val;
          this.linkValue = val;
        } else {
          this.value = _.get(val, "_id", null);
          this.linkValue = _.get(val, "_id", null);
        }
        break
      }
      case "usergroup":
      case "deptgroup": {
        val = this.field.getValue()
        this.cacheValue = val;
        let value = [];
        _.forEach(val, (item) => {
          var v = null;
          if (_.isString(item)) {
            v = item;
          } else {
            v = _.get(item, "_id", null);
          }
          if (v) {
            value.push(v)
          }
        })
        this.value = value;
        this.linkValue = value;
        break;
      }
      case 'number': {
        val = this.field.getValue()
        if (_.isNil(val)) {
          val = null;
        } else {
          val = parseFloat(val);
        }
        this.linkValue = this.value = val;
        break;
      }
      default:
        val = this.field.getValue()
        this.linkValue = this.value = val;
        break;
    }

    if (this.form) {
      this.form.setValue(this);
      this.form.getCacheValue();
    }
    cb && cb();

  }

  getLinkValue = function () {
    switch (this.type) {
      case 'number': {
        if (_.isNil(this.linkValue)) {
          return null;
        }
        return this.linkValue;
      }
      case "linkdata": {
        if (_.isObjectEmpty(this.linkValue)) {
          return null;
        }
        return this.linkValue.key;
      }
      case "text":
      case "textarea": {
        if (_.isNil(this.linkValue)) {
          return '';
        }
        if (typeof this.linkValue == 'string') {
          return this.linkValue.trim();
        }
        if (Array.isArray(this.linkValue)) {
          return this.linkValue.join(',');
        }
        return String(this.linkValue);
      }
      default: {
        return this.linkValue;
      }
    }
  }

  getValue = function () {
    switch (this.type) {
      case 'number': {
        if (_.isNil(this.linkValue)) {
          return null;
        }
        return this.linkValue
      }
      case "text":
      case "textarea": {
        if (_.isNil(this.linkValue)) {
          return '';
        }
        if (typeof this.linkValue == 'string') {
          return this.linkValue.trim();
        }
        if (Array.isArray(this.linkValue)) {
          return this.linkValue.join(',');
        }
        return String(this.linkValue);
      }
      default: {
        if (_.isNil(this.linkValue)) {
          return null;
        }
        return this.linkValue
      }
    }
  }

  getText = function () {
    switch (this.type) {
      case 'number': {
        if (_.isNil(this.linkValue)) {
          return '';
        }
        return this.linkValue + '';
      }
      default: {
        if (_.isNil(this.linkValue)) {
          return '';
        }
        return this.linkValue + '';
      }
    }

  }

  setLoadItems = function (items) {
    if (this.field) {
      if (this.field.setLoadItems) {
        this.field.setLoadItems(items);
      } else {
        this.items = items || []; //帮助子表单记录属性
      }
    } else {
      this.items = items || []; //帮助子表单记录属性
    }
  }

  getWidgetType = function () {
    return this.type;
  }
  getRely = function () {
    return this.rely
  }
  getWidgetName = function () {
    return this.path;
  }
  isSubformWidget = function () {
    return this.subform ? true : false;
  }
  getSubformName = function () {
    return this.subform;
  }

  getSubformRowId = function () {
    return this.subform ? this.rowId : -1;
  }

  setVisible = (visible) => {
    this.visible = visible
  }

  // checkValidate = () => {
  //   switch (this.type) {
  //     case "user":
  //     case "dept":
  //     case "usergroup":
  //     case "deptgroup": {
  //       if (this.value == null) {
  //         return false;
  //       }
  //       break;
  //     }
  //     case "number": {
  //       if (this.value == null) {
  //         return false;
  //       }
  //       break;
  //     }
  //     case "datetime": {
  //     }
  //   }
  // }

  getVisible = () => {
    return this.visible
  }

  getSubformRowId = function () {
    return this.subform ? this.rowId : -1;
  }


}

export class customError extends Error {
  constructor(message, name) {
    super(message);
    this.name = name;
  }
}